const basicLightbox = {
    _toElement: function(e, t = !1) {
        const n = document.createElement("div");
        return n.innerHTML = e.trim(), !0 === t ? n.children : n.firstChild
    },
    _validateOptions: function(e = {}) {
        return null == (e = Object.assign({}, e)).closable && (e.closable = !0), null == e.className && (e.className = ""), null == e.onShow && (e.onShow = () => {}), null == e.onClose && (e.onClose = () => {}), null == e.trigger && (e.trigger = !1), null == e.focus && (e.focus = !1), e
    },
    _validateContent: function(e) {
        const t = "string" == typeof e,
            n = e instanceof HTMLElement == !0;
        if (!1 === t && !1 === n) throw new Error("Content must be a DOM element/node or string");
        return !0 === t ? Array.from(this._toElement(e, !0)) : "TEMPLATE" === e.tagName ? [e.content.cloneNode(!0)] : Array.from(e.children)
    },
    _containsTag: function(e, t) {
        const n = e.children;
        return 1 === n.length && n[0].tagName === t
    },
    _render: function(e, t) {
        const n = this._toElement(`\n      <div class="basicLightbox ${t.className}">\n        <div class="basicLightbox__placeholder" role="dialog"></div>\n      </div>\n    `),
            i = n.querySelector(".basicLightbox__placeholder");
        e.forEach(e => i.appendChild(e));
        const o = this._containsTag(i, "IMG"),
            s = this._containsTag(i, "VIDEO"),
            l = this._containsTag(i, "IFRAME");
        return !0 === o && n.classList.add("basicLightbox--img"), !0 === s && n.classList.add("basicLightbox--video"), !0 === l && n.classList.add("basicLightbox--iframe"), n
    },
    _show: function(e, t) {
        return document.body.appendChild(e), setTimeout(() => {
            requestAnimationFrame(() => (e.classList.add("basicLightbox--visible"), t()))
        }, 10), !0
    },
    _close: function(e, t) {
        return e.classList.remove("basicLightbox--visible"), setTimeout(() => (!1 === this._visible(e) || e.parentElement.removeChild(e), t()), 410), !0
    },
    _visible: function(e) {
        return null != (e = e || document.querySelector(".basicLightbox")) && !0 === e.ownerDocument.body.contains(e)
    },
    create: function(e, t) {
        e = this._validateContent(e), t = this._validateOptions(t);
        const n = this._render(e, t),
            i = (e, i) => !1 !== t.onShow(s) && this._show(n, () => {
                if ("string" == typeof i && n.querySelectorAll(i) && n.querySelectorAll(i)[0].focus(), "function" == typeof e) return e(s)
            }),
            o = e => !1 !== t.onClose(s) && this._close(n, () => {
                if ("function" == typeof e) return e(s)
            });
        !0 === t.closable && (n.addEventListener("click", e => {
            e.target === n && o()
        }), window.addEventListener("keydown", e => {
            27 == e.keyCode && o()
        }), n.querySelector(".basicLightboxClose") && (n.querySelector(".basicLightboxClose").addEventListener("click", e => {
            e.preventDefault(), o()
        }), n.querySelector(".basicLightboxClose").addEventListener("keydown", e => {
            13 == e.keyCode && o()
        }))), t.trigger && (t.trigger.addEventListener("click", e => {
            e.preventDefault(), i(null, t.focus)
        }), t.trigger.addEventListener("keydown", e => {
            13 == e.keyCode && i(null, t.focus)
        }));
        const s = {
            element: () => n,
            visible: () => this._visible(n),
            show: i,
            close: o
        };
        return s
    }
};
! function() {
    "use strict";

    function o() {
        var o = window,
            t = document;
        if (!("scrollBehavior" in t.documentElement.style) || !0 === o.__forceSmoothScrollPolyfill__) {
            var l, e = o.HTMLElement || o.Element,
                r = 468,
                i = {
                    scroll: o.scroll || o.scrollTo,
                    scrollBy: o.scrollBy,
                    elementScroll: e.prototype.scroll || n,
                    scrollIntoView: e.prototype.scrollIntoView
                },
                s = o.performance && o.performance.now ? o.performance.now.bind(o.performance) : Date.now,
                c = (l = o.navigator.userAgent, new RegExp(["MSIE ", "Trident/", "Edge/"].join("|")).test(l) ? 1 : 0);
            o.scroll = o.scrollTo = function() {
                void 0 !== arguments[0] && (!0 !== f(arguments[0]) ? h.call(o, t.body, void 0 !== arguments[0].left ? ~~arguments[0].left : o.scrollX || o.pageXOffset, void 0 !== arguments[0].top ? ~~arguments[0].top : o.scrollY || o.pageYOffset) : i.scroll.call(o, void 0 !== arguments[0].left ? arguments[0].left : "object" != typeof arguments[0] ? arguments[0] : o.scrollX || o.pageXOffset, void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : o.scrollY || o.pageYOffset))
            }, o.scrollBy = function() {
                void 0 !== arguments[0] && (f(arguments[0]) ? i.scrollBy.call(o, void 0 !== arguments[0].left ? arguments[0].left : "object" != typeof arguments[0] ? arguments[0] : 0, void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : 0) : h.call(o, t.body, ~~arguments[0].left + (o.scrollX || o.pageXOffset), ~~arguments[0].top + (o.scrollY || o.pageYOffset)))
            }, e.prototype.scroll = e.prototype.scrollTo = function() {
                if (void 0 !== arguments[0])
                    if (!0 !== f(arguments[0])) {
                        var o = arguments[0].left,
                            t = arguments[0].top;
                        h.call(this, this, void 0 === o ? this.scrollLeft : ~~o, void 0 === t ? this.scrollTop : ~~t)
                    } else {
                        if ("number" == typeof arguments[0] && void 0 === arguments[1]) throw new SyntaxError("Value could not be converted");
                        i.elementScroll.call(this, void 0 !== arguments[0].left ? ~~arguments[0].left : "object" != typeof arguments[0] ? ~~arguments[0] : this.scrollLeft, void 0 !== arguments[0].top ? ~~arguments[0].top : void 0 !== arguments[1] ? ~~arguments[1] : this.scrollTop)
                    }
            }, e.prototype.scrollBy = function() {
                void 0 !== arguments[0] && (!0 !== f(arguments[0]) ? this.scroll({
                    left: ~~arguments[0].left + this.scrollLeft,
                    top: ~~arguments[0].top + this.scrollTop,
                    behavior: arguments[0].behavior
                }) : i.elementScroll.call(this, void 0 !== arguments[0].left ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, void 0 !== arguments[0].top ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop))
            }, e.prototype.scrollIntoView = function() {
                if (!0 !== f(arguments[0])) {
                    var l = function(o) {
                            for (; o !== t.body && !1 === (e = p(l = o, "Y") && a(l, "Y"), r = p(l, "X") && a(l, "X"), e || r);) o = o.parentNode || o.host;
                            var l, e, r;
                            return o
                        }(this),
                        e = l.getBoundingClientRect(),
                        r = this.getBoundingClientRect();
                    l !== t.body ? (h.call(this, l, l.scrollLeft + r.left - e.left, l.scrollTop + r.top - e.top), "fixed" !== o.getComputedStyle(l).position && o.scrollBy({
                        left: e.left,
                        top: e.top,
                        behavior: "smooth"
                    })) : o.scrollBy({
                        left: r.left,
                        top: r.top,
                        behavior: "smooth"
                    })
                } else i.scrollIntoView.call(this, void 0 === arguments[0] || arguments[0])
            }
        }

        function n(o, t) {
            this.scrollLeft = o, this.scrollTop = t
        }

        function f(o) {
            if (null === o || "object" != typeof o || void 0 === o.behavior || "auto" === o.behavior || "instant" === o.behavior) return !0;
            if ("object" == typeof o && "smooth" === o.behavior) return !1;
            throw new TypeError("behavior member of ScrollOptions " + o.behavior + " is not a valid value for enumeration ScrollBehavior.")
        }

        function p(o, t) {
            return "Y" === t ? o.clientHeight + c < o.scrollHeight : "X" === t ? o.clientWidth + c < o.scrollWidth : void 0
        }

        function a(t, l) {
            var e = o.getComputedStyle(t, null)["overflow" + l];
            return "auto" === e || "scroll" === e
        }

        function d(t) {
            var l, e, i, c, n = (s() - t.startTime) / r;
            c = n = n > 1 ? 1 : n, l = .5 * (1 - Math.cos(Math.PI * c)), e = t.startX + (t.x - t.startX) * l, i = t.startY + (t.y - t.startY) * l, t.method.call(t.scrollable, e, i), e === t.x && i === t.y || o.requestAnimationFrame(d.bind(o, t))
        }

        function h(l, e, r) {
            var c, f, p, a, h = s();
            l === t.body ? (c = o, f = o.scrollX || o.pageXOffset, p = o.scrollY || o.pageYOffset, a = i.scroll) : (c = l, f = l.scrollLeft, p = l.scrollTop, a = n), d({
                scrollable: c,
                method: a,
                startTime: h,
                startX: f,
                startY: p,
                x: e,
                y: r
            })
        }
    }
    "object" == typeof exports && "undefined" != typeof module ? module.exports = {
        polyfill: o
    } : o()
}();
class FacetFiltersForm extends HTMLElement {
    constructor() {
        super(), this.filterData = [], this.onActiveFilterClick = this.onActiveFilterClick.bind(this), this.debouncedOnSubmit = debounce(e => {
            this.onSubmitHandler(e)
        }, 500), this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this)), this.classList.contains("don-t-duplicate") || (document.getElementById("FacetFiltersFormMobile").innerHTML = document.getElementById("FacetFiltersForm").innerHTML, document.getElementById("FacetFiltersFormMobile").addEventListener("input", this.debouncedOnSubmit.bind(this)), document.getElementById("FacetFiltersFormMobile").querySelectorAll(".facets__item").forEach(e => {
            const t = e.querySelector("input").id;
            e.querySelector("label").setAttribute("for", "mobile-" + t), e.querySelector("input").id = "mobile-" + t
        }), document.getElementById("FacetFiltersFormMobile").querySelector(".active-facets").classList.remove("active-facets-desktop"), document.getElementById("FacetFiltersFormMobile").querySelector(".active-facets").classList.add("active-facets-mobile"))
    }
    static setListeners() {
        window.addEventListener("popstate", e => {
            const t = e.state ? e.state.searchParams : FacetFiltersForm.searchParamsInitial;
            t !== FacetFiltersForm.searchParamsPrev && FacetFiltersForm.renderPage(t, null, !1)
        })
    }
    static toggleActiveFacets(e = !0) {
        document.querySelectorAll(".js-facet-remove").forEach(t => {
            t.classList.toggle("disabled", e)
        })
    }
    static renderPage(e, t, r = !0) {
        FacetFiltersForm.searchParamsPrev = e;
        const i = FacetFiltersForm.getSections();
        document.getElementById("main-collection-product-grid").classList.add("loading"), i.forEach(r => {
            const i = `${window.location.pathname}?section_id=${r.section}&${e}`,
                c = e => e.url === i;
            FacetFiltersForm.filterData.some(c) ? FacetFiltersForm.renderSectionFromCache(c, t) : FacetFiltersForm.renderSectionFromFetch(i, t)
        }), r && FacetFiltersForm.updateURLHash(e)
    }
    static renderSectionFromFetch(e, t) {
        fetch(e).then(e => e.text()).then(r => {
            const i = r;
            FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
                html: i,
                url: e
            }], FacetFiltersForm.renderFilters(i, t), FacetFiltersForm.renderProductGrid(i), FacetFiltersForm.renderProductCount(i)
        })
    }
    static renderSectionFromCache(e, t) {
        const r = FacetFiltersForm.filterData.find(e).html;
        FacetFiltersForm.renderFilters(r, t), FacetFiltersForm.renderProductGrid(r), FacetFiltersForm.renderProductCount(r)
    }
    static renderProductGrid(e) {
        const t = (new DOMParser).parseFromString(e, "text/html").getElementById("CollectionProductGrid").innerHTML;
        document.getElementById("CollectionProductGrid").innerHTML = t, window.preloadImages(document.getElementById("CollectionProductGrid"))
    }
    static renderProductCount(e) {
        const t = (new DOMParser).parseFromString(e, "text/html").getElementById("CollectionProductCount");
        t && (document.getElementById("CollectionProductCount").innerHTML = t.innerHTML)
    }
    static renderFilters(e, t) {
        const r = (new DOMParser).parseFromString(e, "text/html"),
            i = r.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter"),
            c = e => {
                if (t && t.target.closest(".js-filter")) return e.dataset.index === t.target.closest(".js-filter").dataset.index
            },
            a = Array.from(i).filter(e => !c(e)),
            s = Array.from(i).find(c);
        a.forEach(e => {
            document.querySelector(`.js-filter[data-index="${e.dataset.index}"]`).innerHTML = e.innerHTML
        }), FacetFiltersForm.renderActiveFacets(r), s && FacetFiltersForm.renderCounts(s, t.target.closest(".js-filter"))
    }
    static renderActiveFacets(e) {
        [".active-facets-mobile", ".active-facets-desktop"].forEach(t => {
            const r = e.querySelector(".active-facets");
            r && document.querySelector(t) && (document.querySelector(t).innerHTML = r.innerHTML)
        }), FacetFiltersForm.toggleActiveFacets(!1)
    }
    static renderCounts(e, t) {
        [".facets__selected"].forEach(r => {
            const i = t.querySelector(r);
            e.querySelector(r) && i && (t.querySelector(r).outerHTML = e.querySelector(r).outerHTML)
        })
    }
    static updateURLHash(e) {
        history.pushState({
            searchParams: e
        }, "", `${window.location.pathname}${e&&"?".concat(e)}`)
    }
    static getSections() {
        return [{
            id: "main-collection-product-grid",
            section: document.getElementById("main-collection-product-grid").dataset.id
        }]
    }
    onSubmitHandler(e) {
        e.preventDefault();
        const t = new FormData(e.target.closest("form")),
            r = new URLSearchParams(t).toString();
        FacetFiltersForm.renderPage(r, e)
    }
    onActiveFilterClick(e) {
        e.preventDefault(), FacetFiltersForm.toggleActiveFacets(), FacetFiltersForm.renderPage(new URL(e.currentTarget.href).searchParams.toString())
    }
}
FacetFiltersForm.filterData = [], FacetFiltersForm.searchParamsInitial = window.location.search.slice(1), FacetFiltersForm.searchParamsPrev = window.location.search.slice(1), customElements.define("facet-filters-form", FacetFiltersForm), FacetFiltersForm.setListeners();
class FacetRemove extends HTMLElement {
    constructor() {
        super(), this.querySelector("a").addEventListener("click", e => {
            e.preventDefault();
            (this.closest("facet-filters-form") || document.querySelector("facet-filters-form")).onActiveFilterClick(e)
        })
    }
}
customElements.define("facet-remove", FacetRemove);
class PriceRange extends HTMLElement {
    constructor() {
        super(), this.querySelectorAll("input").forEach(e => e.addEventListener("change", this.onRangeChange.bind(this))), this.setMinAndMaxValues()
    }
    onRangeChange(e) {
        this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues()
    }
    setMinAndMaxValues() {
        const e = this.querySelectorAll("input"),
            t = e[0],
            r = e[1];
        r.value && t.setAttribute("max", r.value), t.value && r.setAttribute("min", t.value), "" === t.value && r.setAttribute("min", 0), "" === r.value && t.setAttribute("max", r.getAttribute("max"))
    }
    adjustToValidValues(e) {
        const t = Number(e.value),
            r = Number(e.getAttribute("min")),
            i = Number(e.getAttribute("max"));
        t < r && (e.value = r), t > i && (e.value = i)
    }
}
customElements.define("price-range", PriceRange);
class ModalBox extends HTMLElement {
    constructor() {
        if (super(), this.o = {
                show: 10,
                frequency: "day",
                enabled: !0,
                ...JSON.parse(this.dataset.options)
            }, this._modalKey = `modal-${document.location.hostname}-${this.id}`, this._modalStorage = localStorage.getItem(this._modalKey) ? JSON.parse(localStorage.getItem(this._modalKey)) : "empty", this._modalText = this.extractText(this.querySelector("[data-content]")), this.o.enabled) {
            const e = (new Date).getTime(),
                t = Math.round((e - this._modalStorage.shown) / 1e3);
            let o = !1;
            ("empty" == this._modalStorage || "day" == this.o.frequency && t > 86400 || "week" == this.o.frequency && t > 604800 || "month" == this.o.frequency && t > 2419200 || this._modalStorage.content != this._modalText) && (o = !0), o && (setTimeout(() => {
                this.show()
            }, parseInt(1e3 * this.o.show)), setTimeout(() => {
                this.querySelectorAll("[data-close]").forEach(e => e.addEventListener("click", () => {
                    this.hide(!0)
                }))
            }, 100))
        }
        this.setAttribute("style", "")
    }
    show() {
        window.preloadImages(this), this.classList.add("active")
    }
    hide(e = !1) {
        this.classList.remove("active"), e && !Shopify.designMode && localStorage.setItem(this._modalKey, JSON.stringify({
            shown: (new Date).getTime(),
            content: this._modalText
        }))
    }
    extractText(e) {
        let t = document.createElement("span");
        t.innerHTML = e.innerHTML;
        const o = t.textContent || t.innerText;
        return t.remove(), [o].toString().replace(/ +/g, "")
    }
}
customElements.define("modal-box", ModalBox), document.addEventListener("shopify:section:select", e => {
    e.target.classList.contains("mount-popup") && e.target.querySelector("modal-box").show()
}), document.addEventListener("shopify:section:deselect", e => {
    e.target.classList.contains("mount-popup") && e.target.querySelector("modal-box").hide()
});
class ProductVariants extends HTMLElement {
    constructor() {
        super(), this.price = document.querySelector("#product-price-" + this.dataset.id), this.price && (this.priceOriginal = this.price.querySelector(".product__price--original"), this.priceCompare = this.price.querySelector(".product__price--compare"), this.priceUnit = this.price.querySelector(".product__price--unit")), this.productForm = document.querySelector("#product-form-" + this.dataset.id), this.productForm && (this.productQty = this.productForm.querySelector(".product__quantity"), this.addToCart = this.productForm.querySelector(".product__add-to-cart"), this.addToCartText = this.productForm.querySelector(".add-to-cart__text")), this.addEventListener("change", this.onVariantChange), this.updateOptions(), this.updateMasterId(), this.updateUnavailableVariants(), this.productStock = this.querySelector(".variant-quantity"), this.productStock && this.querySelector(".variant-quantity-data") && (this.productStockData = JSON.parse(this.querySelector(".variant-quantity-data").dataset.inventory)), this.updateStock(), this._event = new Event("VARIANT_CHANGE")
    }
    onVariantChange() {
        this.updateOptions(), this.updateMasterId(), this.updateVariantInput(), this.price && this.updatePrice(), this.updateStock(), this.updateUnavailableVariants(), this.updatePickupAvailability(), this.hasAttribute("data-no-history") || this.updateURL(), this.updateDetails(), this.productForm && (this.currentVariant && this.currentVariant.available ? (this.productQty && (this.productQty.style.display = ""), this.addToCart.classList.remove("disabled"), this.productForm.classList.remove("disabled-cart"), this.addToCartText.textContent = KROWN.settings.locales.products_add_to_cart_button) : (this.productQty && (this.productQty.style.display = "none"), this.addToCart.classList.add("disabled"), this.productForm.classList.add("disabled-cart"), this.addToCartText.textContent = KROWN.settings.locales.products_sold_out_variant), this.currentVariant ? this.productForm.classList.remove("unavailable-variant") : (this.productForm.classList.add("unavailable-variant"), this.addToCartText.textContent = KROWN.settings.locales.products_unavailable_variant)), this.dispatchEvent(this._event)
    }
    updateOptions() {
        "select" == this.dataset.type ? this.options = Array.from(this.querySelectorAll(".product-variant-container"), t => t.value) : "radio" == this.dataset.type && (this.options = [], this.querySelectorAll(".product-variant__input").forEach(t => {
            t.checked && this.options.push(t.value)
        }))
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData().find(t => !t.options.map((t, e) => this.options[e] === t).includes(!1))
    }
    updatePrice() {
        this.currentVariant ? (this.priceOriginal.innerHTML = KROWN.helpers.formatMoney(this.currentVariant.price, KROWN.settings.shop_money_format), this.currentVariant.compare_at_price > this.currentVariant.price ? (this.priceCompare.innerHTML = KROWN.helpers.formatMoney(this.currentVariant.compare_at_price, KROWN.settings.shop_money_format), this.priceCompare.style.display = "") : this.priceCompare.style.display = "none", this.currentVariant.unit_price_measurement ? this.priceUnit.innerHTML = `\n\t\t\t\t\t${KROWN.helpers.formatMoney(this.currentVariant.unit_price,KROWN.settings.shop_money_format)} / \n\t\t\t\t\t${1!=this.currentVariant.unit_price_measurement.reference_value?this.currentVariant.unit_price_measurement.reference_value+" ":""}\n\t\t\t\t\t${this.currentVariant.unit_price_measurement.reference_unit}\n\t\t\t\t` : this.priceUnit.innerHTML = "") : (this.priceOriginal.innerHTML = "", this.priceCompare.style.display = "none", this.priceUnit.innerHTML = "")
    }
    updateStock() {
        if (this.currentVariant) {
            if (this.productStock && this.productStockData) {
                let t = !1;
                for (const e of this.productStockData)
                    if (e.id == this.currentVariant.id) {
                        t = e;
                        break
                    }
                this.productStock.innerHTML = "", t && (t.quantity <= 0 ? "continue" == t.inventory ? this.productStock.innerHTML = KROWN.settings.locales.products_preorder : "deny" == t.inventory && (this.productStock.innerHTML = KROWN.settings.locales.products_no_products) : "1" == t.quantity ? this.productStock.innerHTML = KROWN.settings.locales.products_one_product : t.quantity <= 5 ? this.productStock.innerHTML = KROWN.settings.locales.products_few_products.replace("{{ count }}", t.quantity) : t.unavailable ? this.productStock.innerHTML = KROWN.settings.locales.products_no_products : t.quantity > 5 && "always" == this.productStock.dataset.type && (this.productStock.innerHTML = KROWN.settings.locales.products_few_products.replace("{{ count }}", t.quantity)))
            }
        } else this.productStock && (this.productStock.innerHTML = "")
    }
    updateDetails() {
        document.querySelectorAll(`#product-${this.dataset.id} .product__sku`).forEach(t => {
            this.currentVariant.sku ? t.innerHTML = KROWN.settings.locales.product_sku + this.currentVariant.sku : t.innerHTML = ""
        }), document.querySelectorAll(`#product-${this.dataset.id} .product__barcode`).forEach(t => {
            this.currentVariant.barcode ? t.innerHTML = KROWN.settings.locales.product_sku + this.currentVariant.barcode : t.innerHTML = ""
        })
    }
    updatePickupAvailability() {
        const t = document.querySelector("pickup-availability");
        t && (this.currentVariant && this.currentVariant.available ? t.fetchAvailability(this.currentVariant.id) : (t.removeAttribute("available"), t.innerHTML = ""))
    }
    updateUnavailableVariants() {
        if ("true" == this.dataset.hideVariants) {
            let t = {},
                e = {},
                i = {},
                r = null,
                a = null;
            this.dataset.variants > 1 && (r = this._getSelectedOption(0), this._resetDisabledOption(1)), this.dataset.variants > 2 && (a = this._getSelectedOption(1), this._resetDisabledOption(2)), this.getVariantData().forEach(s => {
                this.dataset.variants > 0 && (t[s.option1] || (t[s.option1] = []), t[s.option1].push(String(s.available))), this.dataset.variants > 1 && (e[s.option2] || (e[s.option2] = []), e[s.option2].push(String(s.available))), 2 == this.dataset.variants && (s.option1 != r || s.available || this._setDisabledOption(1, s.option2)), this.dataset.variants > 2 && (i[s.option3] || (i[s.option3] = []), i[s.option3].push(String(s.available)), s.option2 != a || s.option1 != r || s.available || this._setDisabledOption(2, s.option3))
            }), this.dataset.variants > 0 && Object.keys(t).forEach(e => {
                t[e].includes("true") || this.querySelectorAll(".product-variant")[0].querySelector(`.product-variant-value[value="${e}"]`).setAttribute("disabled", "disabled")
            }), this.dataset.variants > 1 && Object.keys(e).forEach(t => {
                e[t].includes("true") || this.querySelectorAll(".product-variant")[1].querySelector(`.product-variant-value[value="${t}"]`).setAttribute("disabled", "disabled")
            }), this.dataset.variants > 2 && (Object.keys(i).forEach(t => {
                i[t].includes("true") || this.querySelectorAll(".product-variant")[2].querySelector(`.product-variant-value[value="${t}"]`).setAttribute("disabled", "disabled")
            }), Object.keys(e).forEach(t => {
                e[t].includes("true") || a == t && this.querySelectorAll(".product-variant")[2].querySelector(".product-variant-value").setAttribute("disabled", "disabled")
            }))
        }
    }
    _getSelectedOption(t) {
        if ("select" == this.dataset.type) return this.querySelectorAll(".product-variant")[t].querySelector(".product-variant-container").value;
        if ("radio" == this.dataset.type) {
            let e = null;
            return this.querySelectorAll(".product-variant")[t].querySelectorAll(".product-variant__input").forEach(t => {
                t.checked && (e = t.value)
            }), e
        }
    }
    _resetDisabledOption(t) {
        this.querySelectorAll(".product-variant")[t].querySelectorAll(".product-variant-value").forEach(t => {
            t.removeAttribute("disabled")
        })
    }
    _setDisabledOption(t, e) {
        this.querySelectorAll(".product-variant")[t].querySelector(`.product-variant-value[value="${e}"]`).setAttribute("disabled", "disabled")
    }
    updateURL() {
        this.currentVariant && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`)
    }
    updateVariantInput() {
        if (!this.currentVariant) return;
        document.querySelectorAll(`#product-form-${this.dataset.id}, #product-form-installment`).forEach(t => {
            const e = t.querySelector('input[name="id"]');
            e.value = this.currentVariant.id, e.dispatchEvent(new Event("change", {
                bubbles: !0
            }))
        })
    }
    getVariantData() {
        return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData
    }
}
customElements.define("product-variants", ProductVariants);
class ProductForm extends HTMLElement {
    constructor() {
        super(), this.init()
    }
    init() {
        this.hasAttribute("data-ajax-cart") && !document.body.classList.contains("template-cart") && (this.form = this.querySelector("form"), this.form.addEventListener("submit", this.onSubmitHandler.bind(this)), this.ADD_TO_CART = new Event("add-to-cart"))
    }
    onSubmitHandler(t) {
        t.preventDefault();
        const e = this.querySelector('[type="submit"]');
        e.classList.add("working");
        const i = serializeForm(this.form);
        let r = "";
        fetch(KROWN.settings.routes.cart_add_url + ".js", {
            body: i,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "X-Requested-With": "XMLHttpRequest"
            },
            method: "POST"
        }).then(t => t.json()).then(t => 422 == t.status ? (r = document.createElement("span"), r.className = "alert body-text-sm alert--error", r.innerHTML = t.description, fetch("?section_id=cart-helper")) : fetch("?section_id=cart-helper")).then(t => t.text()).then(t => {
            const e = (new DOMParser).parseFromString(t, "text/html"),
                i = e.getElementById("AjaxCartForm").innerHTML,
                a = e.getElementById("AjaxCartSubtotal").innerHTML,
                s = document.getElementById("AjaxCartForm");
            s.innerHTML = i, s.ajaxifyCartItems(), "" != r && document.getElementById("AjaxCartForm").querySelector("form").prepend(r), document.getElementById("AjaxCartSubtotal").innerHTML = a, window.preloadImages(s), document.querySelector("[data-header-cart-count]").textContent = document.querySelector("#AjaxCartForm [data-cart-count]").textContent, this.dispatchEvent(this.ADD_TO_CART)
        }).catch(t => {
            console.log(t)
        }).finally(() => {
            e.classList.remove("working")
        })
    }
}
customElements.define("product-form", ProductForm);
class PickupAvailability extends HTMLElement {
    constructor() {
        super(), this.errorHtml = this.querySelector("template").content.firstElementChild.cloneNode(!0), this.onClickRefreshList = this.onClickRefreshList.bind(this), this.hasAttribute("available") && this.fetchAvailability(this.dataset.variantId)
    }
    fetchAvailability(t) {
        const e = `${this.dataset.baseUrl}variants/${t}/?section_id=pickup-availability`;
        fetch(e).then(t => t.text()).then(t => {
            const e = (new DOMParser).parseFromString(t, "text/html").querySelector(".shopify-section");
            this.renderPreview(e)
        }).catch(t => {
            console.log(t), this.querySelector("button") && this.querySelector("button").removeEventListener("click", this.onClickRefreshList), this.renderError()
        })
    }
    onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId)
    }
    renderError() {
        this.innerHTML = "", this.appendChild(this.errorHtml), this.querySelector("button").addEventListener("click", this.onClickRefreshList)
    }
    renderPreview(t) {
        const e = document.getElementById("PickupAvailabilityDrawer");
        if (e && e.remove(), !t.querySelector("pickup-availability-preview")) return this.innerHTML = "", void this.removeAttribute("available");
        this.innerHTML = t.querySelector("pickup-availability-preview").outerHTML, this.setAttribute("available", ""), document.body.appendChild(t.querySelector("#PickupAvailabilityDrawer")), this.querySelector("button").addEventListener("click", t => {
            document.getElementById("PickupAvailabilityDrawer").show(t.target)
        }), this.querySelector("button").addEventListener("keyup", t => {
            t.keyCode == window.KEYCODES.RETURN && document.getElementById("PickupAvailabilityDrawer").querySelector("[data-close]").focus()
        })
    }
}
customElements.define("pickup-availability", PickupAvailability);
class ProductImageZoom extends HTMLElement {
    constructor() {
        super(),
        document.getElementById("zoom") ? this.zoom = document.getElementById("zoom") : (this.zoom = document.createElement("div"),
        this.zoom.id = "zoom", this.zoom.innerHTML = `\n\t\t\t\t<img />\n\t\t\t\t<span class="zoom__exit">${KROWN.settings.symbols.zoom_out}</span>\n\t\t\t\t<div class="zoom__overlay"></div>\n\t\t\t`,
        document.body.append(this.zoom),
        this.zoom.querySelector(".zoom__exit").addEventListener("click", this._productZoomUnmount.bind(this))),
        this.zoom.addEventListener("click", this._productZoomUnmount.bind(this)),
        this.onMouseMoveHandlerBinded = this.onMouseMoveHandler.bind(this),
        this.onResizeHandlerBinded = this.onResizeHandler.bind(this),
        this.addEventListener("click", t => {
            this.zoom.classList.add("opened"), this.image = this.zoom.querySelector("img"), this.image.src = this.getAttribute("data-image"), this.image.naturalWidth > 0 ? this._productZoomMount() : this.image.addEventListener("load", this._productZoomMount.bind(this))
        })
    }
    onMouseMoveHandler(t) {
        window.clientX = t.clientX, window.clientY = t.clientY;
        const e = t.clientX * (window.innerWidth - this.image.offsetWidth) / window.innerWidth,
            i = t.clientY * (window.innerHeight - this.image.offsetHeight) / window.innerHeight;
        this.image.style.left = e + "px", this.image.style.top = i + "px"
    }
    onResizeHandler() {
        const t = 1;
        this.image.classList.contains("portrait") ? (this.image.style.width = window.innerWidth * t + "px", this.image.style.height = window.innerWidth * t / this.image.dataset.ratio + "px") : (this.image.style.height = window.innerHeight * t + "px", this.image.style.width = window.innerHeight * t * this.image.dataset.ratio + "px", this.image.offsetWidth < window.innerWidth && (this.image.style.width = window.innerWidth * t + "px", this.image.style.height = window.innerWidth * t / this.image.dataset.ratio + "px"));
        window.clientX, window.innerWidth, this.image.offsetWidth, window.innerWidth, window.clientY, window.innerHeight, this.image.offsetHeight, window.innerHeight
    }
    _productZoomMount(t) {
        this.image.style.left = 0, this.image.style.top = 0, window.addEventListener("mousemove", this.onMouseMoveHandlerBinded, {
            passive: !0
        }), this.image.dataset.ratio = this.image.naturalWidth / this.image.naturalHeight, window.addEventListener("resize", this.onResizeHandlerBinded, {
            passive: !0
        }), this.onResizeHandler(), setTimeout(() => {
            (document.body.classList.contains("touch") || document.body.classList.contains("touchevents")) && (this.zoom.scrollTop = (window.innerHeight - this.image.offsetHeight) / -2, this.zoom.scrollLeft = (window.innerWidth - this.image.offsetWidth) / -2), this.zoom.classList.add("loaded")
        }, 50)
    }
    _productZoomUnmount() {
        this.zoom.classList.remove("opened"), setTimeout(() => {
            window.removeEventListener("resize", this.onResizeHandlerBinded), window.removeEventListener("mousemove", this.onMouseMoveHandlerBinded);
            const t = document.querySelector("#zoom img");
            t.src = "", t.className = "", t.style = "", this.zoom.classList.remove("loaded")
        }, 300)
    }
}
customElements.define("product-image-zoom", ProductImageZoom);
class SearchForm extends HTMLElement {
    constructor() {
        if (super(), this.cachedResults = {}, this.input = this.querySelector("[data-search-input]"), this.predictiveSearchResults = this.querySelector("[data-search-results]"), this.results = [], this.preloader = !1, "false" != KROWN.settings.predictive_search_enabled) {
            let e = this.input.value;
            this.input.addEventListener("keyup", debounce(t => {
                this.input.value != e ? (e = this.input.value, this.getSearchResults(this.input.value.trim())) : "" == this.input.value && this.clearSearchResults()
            }, 150)), this.input.addEventListener("keydown", e => {
                -1 != this.a11yIndex && (e.keyCode !== window.KEYCODES.UP && e.keyCode !== window.KEYCODES.DOWN && e.keyCode !== window.KEYCODES.RETURN || e.preventDefault())
            }), this.input.addEventListener("keyup", e => e.keyCode === window.KEYCODES.UP ? (this.navigateThrough("UP"), !0) : e.keyCode === window.KEYCODES.DOWN ? (this.navigateThrough("DOWN"), !0) : void(e.keyCode === window.KEYCODES.RETURN && -1 != this.a11yIndex && (document.location.href = this.results[this.a11yIndex].querySelector("a"))))
        }
    }
    getSearchResults(e = "") {
        this.preloadSearchResults();
        const t = e.replace(" ", "-").toLowerCase();
        this.cachedResults[t] ? this.renderSearchResults(this.cachedResults[t]) : (this.a11yIndex = -1, fetch(`${KROWN.settings.routes.predictive_search_url}?q=${encodeURIComponent(e)}&resources[type]=${this.dataset.resourceType}&resources[limit]=4&section_id=predictive-search`).then(e => {
            if (!e.ok) {
                var t = new Error(e.status);
                throw this.clearSearchResults(), t
            }
            return e.text()
        }).then(e => {
            const s = (new DOMParser).parseFromString(e, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
            this.cachedResults[t] = s, this.renderSearchResults(s)
        }).catch(e => {
            throw e
        }))
    }
    clearSearchResults() {
        this.predictiveSearchResults.innerHTML = "", this.preloader = !1, this.results = []
    }
    preloadSearchResults() {
        this.preloader || (this.preloader = !0, this.predictiveSearchResults.innerHTML = KROWN.settings.predictive_search_placeholder)
    }
    renderSearchResults(e) {
        this.predictiveSearchResults.innerHTML = e, this.preloader = !1, this.results = this.predictiveSearchResults.querySelectorAll(".search-item, .sidebar__search-link"), window.preloadImages(this.predictiveSearchResults)
    }
    navigateThrough(e) {
        -1 == this.a11yIndex ? this.a11yIndex = 0 : (this.results[this.a11yIndex].classList.remove("active"), "UP" == e ? this.a11yIndex - 1 >= -1 && this.a11yIndex-- : "DOWN" == e && this.a11yIndex + 1 < this.results.length && this.a11yIndex++), this.a11yIndex >= 0 ? (this.results[this.a11yIndex].classList.add("active"), document.getElementById("site-search-sidebar").scrollTop = this.results[this.a11yIndex].offsetTop - 200) : document.getElementById("site-search-sidebar").scrollTop = 0
    }
}
customElements.define("search-form", SearchForm);
class CSSSlider extends HTMLElement {
    constructor() {
        super(), this._touchScreen = "ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch;
        const e = navigator.userAgent.toLowerCase();
        this._ios15 = this._touchScreen && e.includes("applewebkit") && (e.includes("os 15_") || e.includes("version/15")), this.o = {
            selector: ".css-slide",
            snapping: !0,
            groupCells: !1,
            autoHeight: !1,
            navigation: !0,
            navigationDOM: '<span class="css-slider-button css-slider-prev" style="display:none">←</span>\n\t\t\t\t\t<span class="css-slider-button css-slider-next" style="display:none">→</span>',
            thumbnails: !0,
            thumbnailsDOM: '<div class="css-slider-dot-navigation" style="display:none"></div>',
            indexNav: !1,
            indexNavDOM: '<div class="css-slider-index-navigation"><span class="css-slider-current">1</span> / <span class="css-slider-total">1</span></div>',
            watchCSS: !1,
            undisplay: !1,
            listenScroll: !1,
            ...JSON.parse(this.dataset.options)
        }, this.o.watchCSS ? (this.RESIZE_WATCHER = debounce(() => {
            const e = window.getComputedStyle(this, ":after").content;
            e.includes("css-slide") && !this.sliderEnabled ? this.initSlider() : !e.includes("css-slide") && this.sliderEnabled && this.destroySlider()
        }, 100), window.addEventListener("resize", this.RESIZE_WATCHER), this.RESIZE_WATCHER()) : this.initSlider()
    }
    destroySlider() {
        this.innerHTML = "" + this.originalHTML, this.classList.remove("enabled"), this.sliderEnabled = !1, window.removeEventListener("resize", this.RESIZE_EVENT), window.removeEventListener("scroll", this.SCROLL_EVENT), window.removeEventListener("scroll", this.SCROLL_EVENT_ANIMATION), window.preloadImages(this)
    }
    initSlider() {
        if (this._readyEvent = new CustomEvent("ready"), this._changeEvent = new CustomEvent("change"), this._scrollEvent = new CustomEvent("scroll"), this._navEvent = new CustomEvent("navigation"), this._pointerDownEvent = new CustomEvent("pointerDown"), this._pointerUpEvent = new CustomEvent("pointerUp"), this.classList.add("css-slider"), this.originalHTML = this.innerHTML, this.innerHTML = `<div class="css-slider-viewport">\n      <div class="css-slider-holder">\n        <div class="css-slider-container">\n          ${this.originalHTML}\n        </div>\n      </div>\n    </div>`, window.preloadImages(this), this.o.undisplay && this.querySelectorAll("" + this.o.selector).forEach(e => {
                e.style.display = "block"
            }), ".css-slide" != this.o.selector && this.querySelectorAll("" + this.o.selector).forEach(e => {
                e.classList.add("css-slide")
            }), this.element = this.querySelector(".css-slider-holder"), this.o.groupCells && (this.element.scrollLeft = 0), this.items = this.querySelectorAll("" + this.o.selector), this.indexedItems = [], this.index = 0, this.length = this.items.length, this.windowWidth = window.innerWidth, this.querySelector(".css-slider-container").addEventListener("mousedown", e => {
                e.preventDefault()
            }), this.viewport = this.querySelector(".css-slider-viewport"), this.o.autoHeight && this.viewport.classList.add("auto-height"), this.o.navigation || this.o.thumbnails || this.indexNav) {
            let e = document.createElement("div");
            e.classList.add("css-slider-navigation-container"), e.innerHTML = `\n        ${this.o.navigation?this.o.navigationDOM:""}\n        ${this.o.thumbnails?this.o.thumbnailsDOM:""}\n        ${this.o.indexNav?this.o.indexNavDOM:""}`, this.o.navigation && (this.prevEl = e.querySelector(".css-slider-prev"), this.prevEl.addEventListener("click", e => {
                this.changeSlide("prev"), this.dispatchEvent(this._navEvent)
            }), this.nextEl = e.querySelector(".css-slider-next"), this.nextEl.addEventListener("click", e => {
                this.changeSlide("next"), this.dispatchEvent(this._navEvent)
            })), this.o.thumbnails && (this.thumbnailsEl = e.querySelector(".css-slider-dot-navigation")), this.o.indexNav && (this.indexEl = e.querySelector(".css-slider-current"), this.lengthEl = e.querySelector(".css-slider-total")), this.append(e)
        }
        this.length > 1 && (this.RESIZE_EVENT = debounce(() => {
            this.windowWidth != window.innerWidth && this.o.groupCells && this.resetSlider(), this.o.groupCells || this.checkSlide(), this.windowWidth = window.innerWidth
        }, 100), window.addEventListener("resize", this.RESIZE_EVENT), this.resetSlider(!0), this.o.listenScroll && (this.SCROLL_EVENT_ANIMATIONS = () => {
            let e = -this.querySelector(".css-slider-container").offsetWidth;
            this.items.forEach(s => {
                e += s.offsetWidth
            }), this.progress = this.element.scrollLeft / e, this.dispatchEvent(this._scrollEvent)
        }, this.element.addEventListener("scroll", this.SCROLL_EVENT_ANIMATIONS, {
            passive: !0
        })), this.SCROLL_EVENT = debounce(() => {
            if (!this._sliderBlockScroll) {
                const e = this.indexedItems.entries(),
                    s = Array.from(e, e => Math.abs(e[1].offsetLeft - this.element.scrollLeft)),
                    t = Math.min(...s),
                    i = s.indexOf(t);
                i != this.index && (this.index = i, this.checkSlide(), this.dispatchEvent(this._changeEvent))
            }
        }, 10), this.element.addEventListener("scroll", this.SCROLL_EVENT, {
            passive: !0
        }), this._touchScreen || this.element.classList.contains("css-slider--singular") || (this.element.addEventListener("mousedown", e => {
            this.element.classList.contains("css-slider--disable-dragging") || (this.mouseX = e.screenX, this.element.classList.add("can-drag"), this.element.classList.add("mouse-down"))
        }), this.element.addEventListener("mouseup", e => {
            this.element.classList.remove("mouse-down"), this.element.classList.remove("can-drag"), this.element.classList.remove("pointer-events-off")
        }), this.element.addEventListener("mouseleave", e => {
            this.element.classList.remove("mouse-down"), this.element.classList.remove("can-drag"), this.element.classList.remove("pointer-events-off")
        }), this.element.addEventListener("mousemove", e => {
            if (this.element.classList.contains("can-drag")) {
                this.element.classList.add("pointer-events-off");
                let s = this.mouseX - e.screenX;
                Math.abs(s) > 1 && (s > 0 ? (this.changeSlide("next"), this.element.classList.remove("can-drag")) : s < 0 && (this.changeSlide("prev"), this.element.classList.remove("can-drag")))
            }
        })), "scrollBehavior" in document.documentElement.style || this._touchScreen || this.element.classList.add("force-disable-snapping")), this.classList.add("enabled"), this.sliderEnabled = !0, this.dispatchEvent(this._readyEvent)
    }
    changeSlide(e, s = "smooth") {
        "next" == e ? this.index + 1 < this.length && this.index++ : "prev" == e ? this.index - 1 >= 0 && this.index-- : parseInt(e) >= 0 && (this.index = parseInt(e)), this._sliderBlockScroll = !0, this._ios15 && this.element.classList.add("force-disable-snapping"), setTimeout(() => {
            this._sliderBlockScroll = !1, this._ios15 && this.element.classList.remove("force-disable-snapping")
        }, 500), this.checkSlide(), this.element.scrollTo({
            top: 0,
            left: this.indexedItems[this.index].offsetLeft - parseInt(getComputedStyle(this.indexedItems[0]).marginLeft),
            behavior: s
        }), this.dispatchEvent(this._changeEvent)
    }
    checkSlide() {
        this.o.navigation && (this.prevEl.classList.remove("disabled"), this.nextEl.classList.remove("disabled"), 0 == this.index && this.prevEl.classList.add("disabled"), this.index == this.length - 1 && this.nextEl.classList.add("disabled")), this.o.thumbnails && this.thumbnails && (this.thumbnails.forEach(e => {
            e.classList.remove("active")
        }), this.thumbnails[this.index].classList.add("active")), this.o.indexNav && (this.indexEl.textContent = this.index + 1), this.o.autoHeight && (this.viewport.style.height = this.indexedItems[this.index].offsetHeight + "px"), this.indexedItems.forEach((e, s) => {
            s == this.index ? e.classList.add("css-slide-active") : e.classList.remove("css-slide-active")
        })
    }
    afterAppend() {
        this.items = this.querySelectorAll("" + this.o.selector)
    }
    resetSlider(e = !1, s = !0) {
        let t = 0,
            i = 0,
            n = 0,
            l = this.querySelector(".css-slider-container").offsetWidth,
            h = !1;
        if (this.indexedItems = [], this.element.classList.add("disable-snapping"), this.items.forEach((e, s) => {
                e.classList.remove("css-slide--snap"), t += e.offsetWidth, t > l && 0 == i && (i = s)
            }), 0 == i && (i = this.items.length, h = !0), this.items.forEach((e, s) => {
                s % i == 0 && (e.classList.add("css-slide--snap"), e.setAttribute("data-index", n++))
            }), this.indexedItems = this.querySelectorAll(".css-slide--snap"), s && (this.index = 0), this.length = Math.ceil(this.items.length / i), this.o.thumbnails) {
            this.thumbnailsEl.innerHTML = "";
            for (let e = 0; e < this.length; e++) {
                let s = document.createElement("span");
                s.classList.add("css-slider-dot"), s.dataset.index = e, this.thumbnailsEl.appendChild(s), s.addEventListener("click", e => {
                    this.changeSlide(e.target.dataset.index)
                })
            }
            this.thumbnails = this.thumbnailsEl.querySelectorAll(".css-slider-dot")
        }
        this.o.indexNav && (this.indexEl.textContent = this.index + 1, this.lengthEl.textContent = this.length), h ? (this.element.classList.add("css-slider--no-drag"), this.o.navigation && (this.prevEl.style.display = "none", this.nextEl.style.display = "none"), this.o.thumbnails && (this.thumbnailsEl.style.display = "none")) : (this.element.classList.remove("css-slider--no-drag"), this.o.navigation && (this.prevEl.style.display = "block", this.nextEl.style.display = "block"), this.o.thumbnails && (this.thumbnailsEl.style.display = "block")), this.checkSlide(), e || this.element.scrollTo({
            top: 0,
            left: 0,
            behavior: "auto"
        }), this.element.classList.remove("disable-snapping")
    }
}
customElements.define("css-slider", CSSSlider), document.addEventListener("shopify:section:load", e => {
    e.target.classList.contains("mount-css-slider") && e.target.querySelector("css-slider") && e.target.querySelectorAll("css-slider").forEach(e => {
        e.enabled && e.resetSlider()
    })
});
class ToggleTab extends HTMLElement {
    constructor() {
        super(), this.titleEl = this.querySelector(".toggle__title"), this.contentEl = this.querySelector(".toggle__content"), this.titleEl.innerHTML = `${this.titleEl.innerHTML}${KROWN.settings.symbols.toggle_pack}`, this.titleEl.addEventListener("click", this.onClickHandler.bind(this)), this.titleEl.addEventListener("keydown", t => {
            t.keyCode == window.KEYCODES.RETURN && this.onClickHandler()
        })
    }
    onClickHandler() {
        this.titleEl.classList.contains("opened") ? (this.titleEl.classList.remove("opened"), this.titleEl.setAttribute("aria-expanded", "false"), this.slideUp(this.contentEl, 200)) : (this.titleEl.classList.add("opened"), this.titleEl.setAttribute("aria-expanded", "true"), this.slideDown(this.contentEl, 200))
    }
    slideUp(t, e) {
        t.style.transitionProperty = "height, margin, padding", t.style.transitionDuration = e + "ms", t.style.boxSizing = "border-box", t.style.height = t.offsetHeight + "px", t.offsetHeight, t.style.overflow = "hidden", t.style.height = 0, t.style.paddingTop = 0, t.style.paddingBottom = 0, t.style.marginTop = 0, t.style.marginBottom = 0, setTimeout(() => {
            t.style.display = "none", t.style.removeProperty("height"), t.style.removeProperty("padding-top"), t.style.removeProperty("padding-bottom"), t.style.removeProperty("margin-top"), t.style.removeProperty("margin-bottom"), t.style.removeProperty("overflow"), t.style.removeProperty("transition-duration"), t.style.removeProperty("transition-property")
        }, e)
    }
    slideDown(t, e) {
        t.style.removeProperty("display");
        var o = window.getComputedStyle(t).display;
        "none" === o && (o = "block"), t.style.display = o;
        var i = t.offsetHeight;
        t.style.overflow = "hidden", t.style.height = 0, t.style.paddingTop = 0, t.style.paddingBottom = 0, t.style.marginTop = 0, t.style.marginBottom = 0, t.offsetHeight, t.style.boxSizing = "border-box", t.style.transitionProperty = "height, margin, padding", t.style.transitionDuration = e + "ms", t.style.height = i + "px", t.style.removeProperty("padding-top"), t.style.removeProperty("padding-bottom"), t.style.removeProperty("margin-top"), t.style.removeProperty("margin-bottom"), setTimeout(() => {
            t.style.removeProperty("height"), t.style.removeProperty("overflow"), t.style.removeProperty("transition-duration"), t.style.removeProperty("transition-property")
        }, e)
    }
}
customElements.define("toggle-tab", ToggleTab), document.addEventListener("shopify:block:select", t => {
    const e = t.target;
    e.classList.contains("toggle") && (e.querySelector(".toggle__title").classList.contains("opened") || e.onClickHandler())
}), document.addEventListener("shopify:block:deselect", t => {
    const e = t.target;
    e.classList.contains("toggle") && e.querySelector(".toggle__title").classList.contains("opened") && e.onClickHandler()
});
const isAutoplaySupported = A => {
    if ("function" != typeof A) return !1;
    if (sessionStorage.getItem("autoplaySupported")) "true" == sessionStorage.getItem("autoplaySupported") ? A(!0) : A(!1);
    else {
        const e = "data:video/mp4;base64,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";
        let t = !1,
            o = document.createElement("video");
        o.setAttribute("playsinline", "playsinline"), o.setAttribute("muted", "muted"), o.setAttribute("autoplay", "autoplay"), o.setAttribute("loop", "loop"), o.setAttribute("controls", "controls"), o.setAttribute("width", 20), o.setAttribute("height", 20), o.onplay = () => {
            t = !0
        }, o.setAttribute("src", e), o.style.position = "fixed", o.style.top = "-20px", o.style.left = "0px", o.style.zIndex = "997", document.querySelector("body").appendChild(o);
        let s = o.play();
        void 0 !== s && s.then(() => {
            A(!0), sessionStorage.setItem("autoplaySupported", "true"), o.remove()
        }).catch(e => {
            t || e.toString().includes("interact with the document") ? (A(!0), sessionStorage.setItem("autoplaySupported", "true")) : (A(!1), sessionStorage.setItem("autoplaySupported", "false")), o.remove()
        })
    }
};
class VideoPopup extends HTMLElement {
    constructor() {
        super(), this.querySelector(".video-popup__link").addEventListener("click", A => {
            A.preventDefault();
            const e = document.createElement("div");
            e.classList.add("video-popup__blackout"), this.append(e), setTimeout(() => {
                e.style.opacity = "1"
            }, 10), this.classList.add("video-opened"), this.querySelector(".video-popup__close") && this.querySelector(".video-popup__close").addEventListener("click", A => {
                this.querySelectorAll("iframe, video").forEach(A => {
                    A.remove()
                }), e.remove(), this.classList.remove("video-opened")
            }), setTimeout(() => {
                pauseAllMedia(), this.querySelector(".video-popup__container").appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), setTimeout(() => {
                    playMedia(this.closest("[data-video]"))
                }, 500)
            }, 50)
        })
    }
}
customElements.define("video-popup", VideoPopup);
class VideoBackground extends HTMLElement {
    constructor() {
        super(), isAutoplaySupported(A => {
            if (true) {
              const A = this.querySelector(".video-text__background");
              A &&
                ((A.innerHTML = `<video autoplay muted loop playsinline><source type="video/mp4" src="${A.dataset.src}"></video>`),
                A.querySelector("video").play(),
                setTimeout(() => {
                  A.querySelector("video").style.opacity = "1";
                }, 200));
            } else this.querySelector(".video-text__background .video-text__image").style.display = "block";
        })
    }
}
customElements.define("video-background", VideoBackground);

function debounce(e, t) {
    let o;
    return (...a) => {
        clearTimeout(o), o = setTimeout(() => e.apply(this, a), t)
    }
}
KROWN.helpers = {
    formatMoney: function(e, t) {
        "string" == typeof e && (e = e.replace(".", ""));
        let o = "";
        const a = /\{\{\s*(\w+)\s*\}\}/,
            n = t || moneyFormat;

        function r(e, t, o, a) {
            if (o = o || ",", a = a || ".", isNaN(e) || null === e) return 0;
            const n = (e = (e / 100).toFixed(t)).split(".");
            return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (n[1] ? a + n[1] : "")
        }
        switch (n.match(a)[1]) {
            case "amount":
                o = r(e, 2);
                break;
            case "amount_no_decimals":
                o = r(e, 0);
                break;
            case "amount_with_comma_separator":
                o = r(e, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                o = r(e, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                o = r(e, 0, " ");
                break;
            case "amount_with_apostrophe_separator":
                o = r(e, 2, "'")
        }
        return n.replace(a, o)
    }
};
const getPseudoContent = e => {
        var t = document.querySelector(e);
        return window.getComputedStyle(t, ":after").getPropertyValue("content")
    },
    pauseAllMedia = () => {
        document.querySelectorAll(".product .js-youtube").forEach(e => {
            e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
        }), document.querySelectorAll(".product .js-vimeo").forEach(e => {
            e.contentWindow.postMessage('{"method":"pause"}', "*")
        }), document.querySelectorAll(".product video").forEach(e => e.pause()), document.querySelectorAll(".product product-model").forEach(e => {
            e.modelViewerUI && e.modelViewerUI.pause()
        })
    },
    playMedia = e => {
        switch (e.dataset.productMediaType) {
            case "video":
                e.querySelector("video").play();
                break;
            case "external_video-youtube":
                e.querySelector(".js-youtube").contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
                break;
            case "external_video-vimeo":
                e.querySelector(".js-vimeo").contentWindow.postMessage('{"method":"play"}', "*")
        }
    }
    /*!
     * Serialize all form data into a SearchParams string
     * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
     * @param  {Node}   form The form to serialize
     * @return {String}      The serialized form data
     */
    ,
    serializeForm = e => {
        let t = [];
        return Array.prototype.slice.call(e.elements).forEach((function(e) {
            !e.name || e.disabled || ["file", "reset", "submit", "button"].indexOf(e.type) > -1 || ("select-multiple" !== e.type ? ["checkbox", "radio"].indexOf(e.type) > -1 && !e.checked || t.push(encodeURIComponent(e.name) + "=" + encodeURIComponent(e.value)) : Array.prototype.slice.call(e.options).forEach((function(o) {
                o.selected && t.push(encodeURIComponent(e.name) + "=" + encodeURIComponent(o.value))
            })))
        })), t.join("&")
    },
    getJSONP = (e, t) => {
        var o = "_" + +new Date,
            a = document.createElement("script"),
            n = document.getElementsByTagName("head")[0] || document.documentElement;
        window[o] = function(e) {
            n.removeChild(a), t && t(e)
        }, a.src = e.replace("callback=?", "callback=" + o), n.appendChild(a)
    },
    trueTypeOf = e => Object.prototype.toString.call(e).slice(8, -1).toLowerCase(),
    htmlEscape = e => e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;"),
    reframe = (e, t) => {
        let o = "string" == typeof e ? document.querySelectorAll(e) : e;
        const a = t || "js-reframe";
        "length" in o || (o = [o]);
        for (let e = 0; e < o.length; e += 1) {
            const t = o[e];
            if (-1 !== t.className.split(" ").indexOf(a) || t.style.width.indexOf("%") > -1) continue;
            const n = (t.getAttribute("height") || t.offsetHeight) / (t.getAttribute("width") || t.offsetWidth) * 100,
                r = document.createElement("div");
            r.className = a;
            const c = r.style;
            c.position = "relative", c.width = "100%", c.paddingTop = n + "%";
            const l = t.style;
            l.position = "absolute", l.width = "100%", l.height = "100%", l.left = "0", l.top = "0", t.parentNode.insertBefore(r, t), t.parentNode.removeChild(t), r.appendChild(t)
        }
    };
window.KEYCODES = {
    TAB: 9,
    ESC: 27,
    DOWN: 40,
    RIGHT: 39,
    UP: 38,
    LEFT: 37,
    RETURN: 13
};
const slideUp = (e, t) => {
        e.style.transitionProperty = "height, margin, padding", e.style.transitionDuration = t + "ms", e.style.boxSizing = "border-box", e.style.height = e.offsetHeight + "px", e.offsetHeight, e.style.overflow = "hidden", e.style.height = 0, e.style.paddingTop = 0, e.style.paddingBottom = 0, e.style.marginTop = 0, e.style.marginBottom = 0, setTimeout(() => {
            e.style.display = "none", e.style.removeProperty("height"), e.style.removeProperty("padding-top"), e.style.removeProperty("padding-bottom"), e.style.removeProperty("margin-top"), e.style.removeProperty("margin-bottom"), e.style.removeProperty("overflow"), e.style.removeProperty("transition-duration"), e.style.removeProperty("transition-property")
        }, t)
    },
    slideDown = (e, t) => {
        e.style.removeProperty("display");
        let o = window.getComputedStyle(e).display;
        "none" === o && (o = "block"), e.style.display = o;
        const r = e.offsetHeight;
        e.style.overflow = "hidden", e.style.height = 0, e.style.paddingTop = 0, e.style.paddingBottom = 0, e.style.marginTop = 0, e.style.marginBottom = 0, e.offsetHeight, e.style.boxSizing = "border-box", e.style.transitionProperty = "height, margin, padding", e.style.transitionDuration = t + "ms", e.style.height = r + "px", e.style.removeProperty("padding-top"), e.style.removeProperty("padding-bottom"), e.style.removeProperty("margin-top"), e.style.removeProperty("margin-bottom"), setTimeout(() => {
            e.style.removeProperty("height"), e.style.removeProperty("overflow"), e.style.removeProperty("transition-duration"), e.style.removeProperty("transition-property")
        }, t)
    };
class MainHeader extends HTMLElement {
    constructor() {
        super(), this.mount()
    }
    mount() {
        const e = document.getElementById("site-nav--mobile");
        document.getElementById("site-menu-handle") && (document.getElementById("site-menu-handle").addEventListener("click", t => {
            t.preventDefault(), document.getElementById("site-menu-handle").setAttribute("aria-expanded", "true"), e.show()
        }), document.getElementById("site-menu-handle").addEventListener("keyup", t => {
            t.keyCode == window.KEYCODES.RETURN && e.querySelector(".site-close-handle").focus()
        }));
        const t = document.getElementById("site-cart");
        document.getElementById("site-cart-handle") && (document.getElementById("site-cart-handle").addEventListener("click", e => {
            e.preventDefault(), document.getElementById("site-cart-handle").setAttribute("aria-expanded", "true"), t.show()
        }), document.getElementById("site-cart-handle").addEventListener("keyup", e => {
            e.keyCode == window.KEYCODES.RETURN && t.querySelector(".site-close-handle").focus()
        }));
        const s = document.getElementById("site-search");
        if (document.getElementById("site-search-handle") && document.getElementById("site-search-handle").addEventListener("click", e => {
                e.preventDefault(), document.getElementById("site-search-handle").setAttribute("aria-expanded", "true"), s.show(), setTimeout(() => {
                    s.querySelector("[data-search-input]").focus()
                }, 10)
            }), document.addEventListener("keydown", e => {
                e.keyCode == window.KEYCODES.ESC && document.querySelector("sidebar-drawer.active") && document.querySelector("sidebar-drawer.active").hide()
            }), document.getElementById("site-overlay").addEventListener("click", () => {
                document.querySelector("sidebar-drawer.active") && document.querySelector("sidebar-drawer.active").hide()
            }), this.RESIZE_SidebarHelper = debounce(() => {
                document.querySelector("sidebar-drawer.active") && (document.querySelector("sidebar-drawer.active").style.height = window.innerHeight + "px")
            }, 200), window.addEventListener("resize", this.RESIZE_SidebarHelper), this.RESIZE_SidebarHelper(), document.querySelector(".site-nav.style--classic > .site-nav-container")) {
            let e = 0,
                t = 0;
            document.querySelectorAll(".site-nav.style--classic > .site-nav-container .primary-menu > ul > li").forEach(t => {
                e += t.offsetWidth
            }), document.querySelectorAll(".site-nav .site-menu-handle").forEach(e => {
                e.classList.contains("hide") || (t += e.offsetWidth)
            }), e > document.getElementById("site-header").offsetWidth - 200 - document.querySelector(".logo").offsetWidth - t && document.body.classList.add("switch-menus")
        }
        if (this.siteHeader = document.getElementById("site-header"), document.querySelector(".site-nav.style--classic")) {
            const e = (this.siteHeader.offsetHeight - document.querySelector(".site-nav.style--classic").offsetHeight) / 2,
                t = document.createElement("style");
            t.id = "site-nav-classic", t.setAttribute("type", "text/css"), t.innerHTML = `.site-nav.style--classic .submenu { padding-top: ${e}px; } .site-nav.style--classic .submenu:after { top: ${e}px; height: calc(100% - ${e}px) !important; } .site-nav.style--classic .submenu.mega-menu { padding-top: ${e+70}px; } .site-nav.style--classic .submenu.mega-menu:after { top: ${e}px; }`, document.getElementsByTagName("head")[0].appendChild(t)
        }
        document.querySelectorAll(".site-nav.style--classic .has-submenu > a").forEach(e => {
            const t = e.parentNode;
            t.addEventListener("keydown", e => {
                e.keyCode == window.KEYCODES.RETURN && (e.target.classList.contains("no-focus-link") || e.preventDefault(), t.classList.contains("focus") ? document.activeElement.parentNode.classList.contains("has-submenu") && t.classList.contains("focus") && (t.classList.remove("focus"), t.setAttribute("aria-expanded", "true")) : (t.classList.add("focus"), t.setAttribute("aria-expanded", "true")))
            }), t.querySelector(".submenu-holder > li:last-child a") && t.querySelector(".submenu-holder > li:last-child a").addEventListener("focusout", e => {
                t.classList.contains("focus") && (t.classList.remove("focus"), t.setAttribute("aria-expanded", "false"))
            })
        }), document.querySelectorAll(".site-nav.style--classic .has-babymenu:not(.mega-link) > a").forEach(e => {
            const t = e.parentNode;
            t.addEventListener("keydown", e => {
                e.keyCode == window.KEYCODES.RETURN && (e.preventDefault(), t.classList.contains("focus") ? (t.classList.remove("focus"), t.setAttribute("aria-expanded", "false")) : (t.classList.add("focus"), t.setAttribute("aria-expanded", "true")))
            }), t.querySelector(".babymenu li:last-child a") && t.querySelector(".babymenu li:last-child a").addEventListener("focusout", e => {
                t.parentNode.classList.contains("focus") && (t.parentNode.classList.remove("focus"), t.parentNode.setAttribute("aria-expanded", "false"))
            })
        }), document.querySelectorAll(".site-nav.style--sidebar .has-submenu:not(.collections-menu)").forEach(e => {
            e.querySelector(":scope > a").addEventListener("click", t => {
                const s = t.currentTarget.parentNode;
                s.classList.contains("active") ? "#" == t.currentTarget.getAttribute("href") && (t.preventDefault(), s.classList.remove("active"), slideUp(s.querySelector(".submenu"), 200), s.querySelector(".submenu").setAttribute("aria-expanded", "false"), e.classList.remove("hover")) : (t.preventDefault(), s.classList.add("active"), slideDown(s.querySelector(".submenu"), 200), s.querySelector(".submenu").setAttribute("aria-expanded", "true"))
            })
        }), document.querySelectorAll(".site-nav.style--sidebar .has-babymenu:not(.collections-menu)").forEach(e => {
            e.querySelector(":scope > a").addEventListener("click", t => {
                const s = t.currentTarget.parentNode;
                s.classList.contains("active") ? "#" == t.currentTarget.getAttribute("href") && (t.preventDefault(), s.classList.remove("active"), slideUp(s.querySelector(".babymenu"), 200), s.querySelector(".babymenu").setAttribute("aria-expanded", "false"), e.classList.remove("hover")) : (t.preventDefault(), s.classList.add("active"), slideDown(s.querySelector(".babymenu"), 200), s.querySelector(".babymenu").setAttribute("aria-expanded", "true"))
            })
        }), this.siteHeader.classList.contains("header-scroll") && (document.body.classList.contains("template-index") && document.body.classList.add("index-margin-fix"), window.lst = window.scrollY, window.lhp = 0, this.SCROLL_StickyHelper = () => {
            var e = window.scrollY;
            e <= 0 && this.siteHeader.classList.contains("fix") && setTimeout(() => {
                this.siteHeader.classList.remove("animate"), this.siteHeader.classList.remove("fix"), this.siteHeader.classList.remove("ready")
            }, 50), e < 0 || Math.abs(lst - e) <= 5 || (e > window.lhp && (0 == e && this.siteHeader.classList.contains("fix") ? (this.siteHeader.classList.remove("animate"), this.siteHeader.classList.remove("fix"), this.siteHeader.classList.remove("ready")) : e <= lst && !this.siteHeader.classList.contains("fix") ? (window.lhp = this.siteHeader.offsetTop, this.siteHeader.classList.add("fix"), setTimeout(() => {
                this.siteHeader.classList.add("ready")
            }, 5), setTimeout(() => {
                this.siteHeader.classList.add("animate")
            }, 25)) : e > lst && this.siteHeader.classList.contains("animate") && (this.siteHeader.classList.remove("animate"), setTimeout(() => {
                this.siteHeader.classList.remove("fix"), this.siteHeader.classList.remove("ready")
            }, 105))), window.lst = e)
        }
        // },
        // window.addEventListener("scroll", this.SCROLL_StickyHelper, {
        //     passive: !0
        // })
        )
    }
    unmount() {
        window.removeEventListener("resize", this.RESIZE_SidebarHelper), window.removeEventListener("scroll", this.SCROLL_StickyHelper)
    }
}
customElements.define("main-header", MainHeader);
class SidebarDrawer extends HTMLElement {
    constructor() {
        super(), this.siteOverlay = document.getElementById("site-overlay"), this.querySelector(".site-close-handle").addEventListener("click", () => {
            this.hide()
        })
    }
    show() {
      let direction = (this.id == "site-nav--mobile") ? "move-right" : "move-left";

        this.style.display = "block", setTimeout(() => {
            this.classList.add("active")
        }, 10), this.siteOverlay.classList.add("active"), document.body.classList.add("sidebar-move", direction), document.querySelector("html").classList.add("kill-overflow"), this.style.height = window.innerHeight + "px", "site-cart" == this.id && document.querySelector("#cart-recommendations css-slider") && document.querySelector("#cart-recommendations css-slider").resetSlider(), this._mountA11YHelper()
    }
    hide() {
        this.classList.remove("active"), this.siteOverlay.classList.remove("active"), document.body.classList.remove("sidebar-move"), document.querySelector("html").classList.remove("kill-overflow"), setTimeout(() => {
            this.style.display = "none"
            document.body.classList.remove("move-right", "move-left")
        }, 250), this._unmountA11YHelper()
    }
    _mountA11YHelper(e) {
        let t = e || this.querySelectorAll('[tabindex="0"], button, [href], input:not([type="hidden"]), select, textarea, .regular-select-cover'),
            s = t[0],
            i = t[t.length - 1];
        "site-cart" == this.id && "0" != this.querySelector(".cart-holder").getAttribute("data-items") && (i = t[t.length - 2]), this.A11Y_TAB_EVENT = ((e, t, s) => {
            ("Tab" === s.key || s.keyCode === window.KEYCODES.TAB) && (s.shiftKey ? document.activeElement === e && (t.focus(), s.preventDefault()) : document.activeElement === t && (e.focus(), s.preventDefault()))
        }).bind(this, s, i), this.addEventListener("keydown", this.A11Y_TAB_EVENT)
    }
    _unmountA11YHelper() {
        this.removeEventListener("keydown", this.A11Y_TAB_EVENT)
    }
}
customElements.define("sidebar-drawer", SidebarDrawer);
class AnnouncementBar extends HTMLElement {
    constructor() {
        super(), document.querySelector(".announcement__exit") && document.querySelector(".announcement__exit").addEventListener("click", () => {
            document.body.classList.remove("show-announcement-bar"), localStorage.setItem("announcement-dismissed", "true"), document.querySelector(".site-header").style.marginTop = "0px", this.style.display = "none"
        })
    }
}
customElements.define("announcement-bar", AnnouncementBar);
class CartForm extends HTMLElement {
    constructor() {
        super(), this.ajaxifyCartItems()
    }
    ajaxifyCartItems() {
        this.form = this.querySelector("form"), this.querySelectorAll(".cart-item").forEach(t => {
            const e = t.querySelector(".remove");
            e && (e.dataset.href = e.getAttribute("href"), e.setAttribute("href", ""), e.addEventListener("click", e => {
                e.preventDefault(), this.updateCartQty(t, 0)
            }));
            const r = t.querySelector(".qty");
            r && (r.addEventListener("input", debounce(e => {
                e.preventDefault(), e.target.blur(), this.updateCartQty(t, parseInt(r.value))
            }, 300)), r.addEventListener("click", t => {
                t.target.select()
            }))
        })
    }
    updateCartQty(t, e) {
        this.form.classList.add("processing"), this.querySelector(".alert") && this.querySelector(".alert").remove();
        const r = JSON.stringify({
            id: t.dataset.id,
            quantity: e
        });
        fetch(KROWN.settings.routes.cart_change_url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/javascript"
            },
            body: r
        }).then(t => {
            if (t.ok) return fetch("?section_id=cart-helper");
            throw new Error("Something went wrong")
        }).then(t => t.text()).then(r => {
            const n = (new DOMParser).parseFromString(r, "text/html"),
                a = n.getElementById("AjaxCartForm").innerHTML,
                o = n.getElementById("AjaxCartSubtotal").innerHTML,
                c = document.getElementById("AjaxCartForm");
            if (c.innerHTML = a, c.ajaxifyCartItems(), document.querySelector("[data-header-cart-count]").textContent = c.querySelector("[data-cart-count]").textContent, 0 == e && document.getElementById("cart-recommendations") && (document.getElementById("cart-recommendations").innerHTML = "", document.getElementById("cart-recommendations").generateRecommendations()), 0 != e && e > parseInt(c.querySelector(`.cart-item[data-id="${t.dataset.id}"]`).dataset.qty)) {
                let e = document.createElement("span");
                e.classList.add("alert", "alert--error"), e.textContent = KROWN.settings.locales.cart_add_error.replace("{{ title }}", t.dataset.title), this.form.prepend(e)
            }
            document.getElementById("AjaxCartSubtotal").innerHTML = o, window.preloadImages(c), document.body.classList.contains("template-cart") && (document.querySelector("#section-cart .box__heading .subtitle").innerHTML = document.querySelector("#AjaxCartForm .subtitle").innerHTML, document.getElementById("AjaxCartSubtotal").querySelector("[data-cart-empty]") ? (document.querySelector("#section-cart .box__heading .subtitle").innerHTML = "", document.getElementById("AjaxCartSubtotal").querySelector(".main-cart-empty-content") ? document.getElementById("AjaxCartSubtotal").querySelector(".main-cart-empty-content").style.display = "block" : document.getElementById("AjaxCartSubtotal").append(document.getElementById("section-cart").querySelector("template").content.cloneNode(!0))) : document.getElementById("AjaxCartSubtotal").querySelector(".main-cart-empty-content") && (document.getElementById("AjaxCartSubtotal").querySelector(".main-cart-empty-content").style.display = "none"))
        }).catch(t => {
            console.log(t);
            let e = document.createElement("span");
            e.classList.add("alert", "alert--error"), e.textContent = KROWN.settings.locales.cart_general_error, this.form.prepend(e)
        }).finally(() => {
            this.form.classList.remove("processing")
        })
    }
}
customElements.define("cart-form", CartForm);
class CartProductQuantity extends HTMLElement {
    constructor() {
        super(), this.querySelector(".qty-minus").addEventListener("click", this.changeCartInput.bind(this)), this.querySelector(".qty-plus").addEventListener("click", this.changeCartInput.bind(this))
    }
    changeCartInput() {
        setTimeout(() => {
            document.getElementById("AjaxCartForm").updateCartQty(this.closest(".cart-item"), parseInt(this.querySelector(".qty").value))
        }, 50)
    }
}
customElements.define("cart-product-quantity", CartProductQuantity);
class CartProductRecommendations extends HTMLElement {
    constructor() {
        super(), this.generateRecommendations()
    }
    generateRecommendations() {
        const t = document.getElementById("AjaxCartForm").querySelectorAll(".cart-item");
        if (t.length > 0) {
            document.createElement("div");
            fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=cart-recommendations&product_id=${t[0].dataset.productId}&limit=6`).then(t => t.text()).then(t => {
                const e = (new DOMParser).parseFromString(t, "text/html").querySelector(".cart-product-recommendations");
                e && e.querySelectorAll(".cart-product-item").length > 0 && (document.getElementById("cart-recommendations").innerHTML = e.innerHTML)
            })
        }
    }
}
customElements.define("cart-product-recommendations", CartProductRecommendations);
class ProductModel extends HTMLElement {
    constructor() {
        super(), Shopify.loadFeatures([{
            name: "model-viewer-ui",
            version: "1.0",
            onLoad: this.setupModelViewerUI.bind(this)
        }])
    }
    setupModelViewerUI(e) {
        if (e) return;
        this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector("model-viewer"));
        const s = this.modelViewerUI.viewer;
        s.addEventListener("shopify_model_viewer_ui_toggle_play", () => {
            s.closest(".css-slider-holder") && s.closest(".css-slider-holder").classList.add("css-slider--disable-dragging")
        }), s.addEventListener("shopify_model_viewer_ui_toggle_pause", () => {
            s.closest(".css-slider-holder") && s.closest(".css-slider-holder").classList.remove("css-slider--disable-dragging")
        }), s.closest(".product-gallery__item") && "0" == s.closest(".product-gallery__item").dataset.index && s.closest(".css-slider-holder") && s.closest(".css-slider-holder").classList.add("css-slider--disable-dragging")
    }
}
customElements.define("product-model", ProductModel), window.ProductModel = {
    loadShopifyXR() {
        Shopify.loadFeatures([{
            name: "shopify-xr",
            version: "1.0",
            onLoad: this.setupShopifyXR.bind(this)
        }])
    }, setupShopifyXR(e) {
        e || (window.ShopifyXR ? (document.querySelectorAll('[id^="ProductJSON-"]').forEach(e => {
            window.ShopifyXR.addModels(JSON.parse(e.textContent)), e.remove()
        }), window.ShopifyXR.setupXRElements()) : document.addEventListener("shopify_xr_initialized", () => this.setupShopifyXR()))
    }
};
class ProductQuantity extends HTMLElement {
    constructor() {
        super();
        const t = this.querySelector(".qty-selector"),
            e = this.querySelector(".qty-minus"),
            s = this.querySelector(".qty-plus"),
            a = t.getAttribute("min") ? parseInt(t.getAttribute("min")) : 1,
            i = t.getAttribute("max") ? parseInt(t.getAttribute("max")) : 999;
        parseInt(t.value) - 1 < a && e.classList.add("disabled"), parseInt(t.value) + 1 > i && s.classList.add("disabled"), e.addEventListener("click", i => {
            if (i.preventDefault(), !e.classList.contains("disabled")) {
                const i = parseInt(t.value);
                i - 1 >= a && (t.value = i - 1, s.classList.remove("disabled")), i - 1 <= a && e.classList.add("disabled")
            }
        }), s.addEventListener("click", a => {
            if (a.preventDefault(), !s.classList.contains("disabled")) {
                const a = parseInt(t.value);
                a + 1 <= i && (t.value = a + 1, e.classList.remove("disabled")), a + 1 >= i && s.classList.add("disabled")
            }
        })
    }
}
customElements.define("product-quantity", ProductQuantity);
class QuickAddToCart extends HTMLElement {
    constructor() {
        super(), this.querySelector("product-form") && this.init()
    }
    init() {
        this.querySelector("product-form").addEventListener("add-to-cart", () => {
            document.body.classList.contains("template-cart") ? (document.querySelector("#section-cart .box__text").scrollIntoView(), document.querySelector("#section-cart .box__heading .subtitle").innerHTML = document.querySelector("#AjaxCartForm .subtitle").innerHTML) : (window.preloadImages(document.getElementById("site-cart")), document.getElementById("site-cart").show(), document.getElementById("cart-recommendations") && document.getElementById("cart-recommendations").generateRecommendations())
        })
    }
}
customElements.define("quick-add-to-cart", QuickAddToCart);
class QuickViewProduct extends HTMLElement {
    constructor() {
        super(), this.querySelector("a") && this.init()
    }
    init() {
        this.quickViewModal = null, this.querySelector("a").addEventListener("click", e => {
            if (e.preventDefault(), this.quickViewModal) this.quickViewModal.show();
            else {
                const t = e.currentTarget;
                t.classList.add("working"), fetch(`${t.getAttribute("href")}${t.getAttribute("href").includes("?")?"&":"?"}view=quick-view`).then(e => e.text()).then(e => {
                    const r = (new DOMParser).parseFromString(e, "text/html").querySelector("#product-product-quick-view");
                    this.quickViewModal = basicLightbox.create(r), this.quickViewModal.show(), t.classList.remove("working");
                    const o = this.quickViewModal.element(),
                        c = o.querySelector(".product-images img"),
                        i = JSON.parse(o.querySelector(".product-images").querySelector('[type="application/json"]').textContent),
                        n = o.querySelector("product-variants");
                    if (n && n.addEventListener("VARIANT_CHANGE", e => {
                            const t = e.target.currentVariant;
                            t && null != t.featured_media && null != i[t.id] && c.setAttribute("srcset", i[t.id])
                        }), !document.body.classList.contains("template-cart") && "overlay" == KROWN.settings.cart_action) {
                        let e = !1;
                        o.querySelector(".product--add-to-cart-button") && o.querySelector(".product--add-to-cart-button").addEventListener("keyup", t => {
                            t.keyCode == window.KEYCODES.RETURN && (e = !0)
                        }), o.querySelector(".product--add-to-cart-form") && o.querySelector(".product--add-to-cart-form").addEventListener("add-to-cart", () => {
                            window.preloadImages(document.getElementById("site-cart")), document.getElementById("site-cart").show(), document.getElementById("cart-recommendations") && document.getElementById("cart-recommendations").generateRecommendations(), e && setTimeout(() => {
                                document.querySelector("#site-cart .sidebar__cart-close").focus()
                            }, 200)
                        })
                    }
                })
            }
        })
    }
}
customElements.define("quick-view-product", QuickViewProduct);
class SiteFilterHandle extends HTMLElement {
    constructor() {
        super();
        const e = document.getElementById("site-filters");
        this.addEventListener("click", t => {
            t.preventDefault(), this.setAttribute("aria-expanded", "true"), e.show()
        }), this.addEventListener("keyup", t => {
            t.keyCode == window.KEYCODES.RETURN && e.querySelector(".site-close-handle").focus()
        })
    }
}
customElements.define("site-filter-handle", SiteFilterHandle);
class ProductPage extends HTMLElement {

    constructor() {

        super();

        if (!this.hasAttribute('data-empty-product')) {

            this.productGallery = this.querySelector('.product-gallery');
            this.productSlider = this.querySelector('css-slider');

            // Gallery thumbnails

            if (this.querySelector('.product-gallery__thumbnails .thumbnail')) {

                this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i) => {
                    if (i == 0)
                        elm.classList.add('active');
                    elm.addEventListener('click', e => {
                        if (this.productSlider?.sliderEnabled) {
                            this.productSlider?.changeSlide(e.currentTarget.dataset.index);
                        } else {
                            window.scrollTo({
                                top: this.productGallery?.querySelector(`.product-gallery-item[data-faux-index="${e.currentTarget.hasAttribute('data-faux-index') ? e.currentTarget.dataset.fauxIndex : e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
                                behavior: 'smooth'
                            });
                            this.thumbnailNavigationHelper(e.currentTarget.dataset.fauxIndex);
                        }
                        pauseAllMedia();
                        //playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
                    });
                })

                this.productSlider?.addEventListener('change', e => {
                    this.thumbnailNavigationHelper(e.target.index);
                });

            }

            this.productSlider?.addEventListener('navigation', e => {
                //playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`));
            })
            this.productSlider?.addEventListener('change', e => {
                if (this.productGallery?.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' && this.xrButton) {
                    this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery?.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
                }
                pauseAllMedia();
                this.thumbnailNavigationHelper(e.target.index);
            });

            // Product variant event listener for theme specific logic

            const productVariants = this.querySelector('product-variants');
            if (productVariants) {
                productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
                this.onVariantChangeHandler({ target: productVariants });
            }

            // show cart drawer when element is added to cart

            if (!document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay') {

                let addToCartEnter = false;
                if (this.querySelector('.product--add-to-cart-button')) {
                    this.querySelector('.product--add-to-cart-button').addEventListener('keyup', e => {
                        if (e.keyCode == window.KEYCODES.RETURN) {
                            addToCartEnter = true;
                        }
                    })
                }

                if (this.querySelector('.product--add-to-cart-form')) {
                    // here
                    this.querySelector('.product--add-to-cart-form').addEventListener('add-to-cart', () => {
                        window.preloadImages(document.getElementById('site-cart'));
                        document.getElementById('site-cart').show();
                        if (document.getElementById('cart-recommendations')) {
                            document.getElementById('cart-recommendations').generateRecommendations();
                        }
                        if (addToCartEnter) {
                            setTimeout(() => {
                                document.querySelector('#site-cart .sidebar__cart-close').focus();
                            }, 200);
                        }
                    });
                }

            }

            // Scroll navigation helper 

            if (this.productGallery != null && this.productGallery.dataset.style == "scroll") {

                this.productGalleryNavigation = this.querySelector('.product-gallery__thumbnails');
                this.productGalleryNavigationItem = this.querySelectorAll('.product-gallery__thumbnails .thumbnail');

                const productGallerySlides = this.productGallery.querySelectorAll('.product-gallery-item');
                const reversedGallerySlides = [...productGallerySlides].reverse();

                const checkIfProductIsFirst = this.parentNode == document.querySelector('#main .mount-product-page:first-child') ? document.querySelector('#main .mount-product-page:first-child .product-gallery__thumbnails') : false;

                this.GALLERY_NAVIGATION_SCROLL = () => {
                    if (!this.productGallery.querySelector('css-slider').sliderEnabled && window.innerWidth > 768) {

                        for (const slide of reversedGallerySlides) {
                            const slideTop = slide.getBoundingClientRect().top;
                            if (slideTop < window.innerHeight / 2 && slideTop > -window.innerHeight / 2) {
                                this.productGalleryNavigationItem.forEach(elm => elm.classList.remove('active'));
                                this.productGalleryNavigationItem[slide.dataset.fauxIndex].classList.add('active');
                                break;
                            }
                        }

                        const productGalleryTop = this.productGallery.getBoundingClientRect().top;
                        if ((productGalleryTop - window.innerHeight) * -1 > this.productGallery.offsetHeight) {
                            this.productGalleryNavigation.classList.add('scroll');
                            this.productGalleryNavigation.classList.remove('scroll-up');
                        } else if (productGalleryTop > 0) {
                            this.productGalleryNavigation.classList.add('scroll-up');
                            this.productGalleryNavigation.classList.add('scroll');
                            if (checkIfProductIsFirst) {
                                checkIfProductIsFirst.style.height = `calc( var(--window-height) + ${window.scrollY}px )`;
                            }
                        } else if ((productGalleryTop - window.innerHeight) * -1 < this.productGallery.offsetHeight) {
                            this.productGalleryNavigation.classList.remove('scroll');
                            this.productGalleryNavigation.classList.remove('scroll-up');
                        }

                    }

                }

                window.addEventListener('scroll', this.GALLERY_NAVIGATION_SCROLL, { passive: true });
                this.GALLERY_NAVIGATION_SCROLL();

            }

            // Slider navigation helper

            if (this.productGallery != null && this.productGallery.dataset.style == "slider") {

                const checkIfProductIsFirst = document.querySelector('#main .mount-product-page:first-child');

                this.GALLERY_NAVIGATION_SCROLL = () => {

                    const productGalleryTop = this.productGallery.getBoundingClientRect().top;

                    if (productGalleryTop > 0) {
                        this.productGallery.classList.add('nav-scroll');
                        if (checkIfProductIsFirst && checkIfProductIsFirst.querySelector('.css-slider-navigation-container')) {
                            checkIfProductIsFirst.querySelector('.css-slider-navigation-container').style.height = `calc( var(--window-height) + ${window.scrollY}px )`;
                        }
                    } else if (productGalleryTop < 0) {
                        this.productGallery.classList.remove('nav-scroll');
                        this.productGallery.classList.remove('nav-scroll-up');
                    }

                }

                window.addEventListener('scroll', this.GALLERY_NAVIGATION_SCROLL, { passive: true });
                this.GALLERY_NAVIGATION_SCROLL();

            }

            // Check for models

            const models = this.querySelectorAll('product-model');
            if (models.length > 0) {
                window.ProductModel.loadShopifyXR();
                this.xrButton = this.querySelector('.product__view-in-space');
            }

            // Change sticky position for text content

            const productContentBox = this.querySelector('.box__product-content');
            const productGalleryBox = this.querySelector('.box__product-gallery');

            this.CONTENT_STICKY_RESIZE = () => {
                productContentBox.style.top = `calc(100vh - ${productContentBox.offsetHeight}px)`;
                productGalleryBox.style.top = `calc(100vh - ${productGalleryBox.offsetHeight}px)`;
            }
            window.addEventListener('resize', this.CONTENT_STICKY_RESIZE, { passive: true });
            this.CONTENT_STICKY_RESIZE();

            const contentObserver = new MutationObserver(mutations => {
                for (const mutation of mutations) {
                    this.CONTENT_STICKY_RESIZE();
                }
            });
            contentObserver.observe(productContentBox, { attributes: true, childList: true, subtree: true });

            // Assist for video popups

            if (this.productGallery != null && this.productGallery.querySelector('video-popup')) {

                const productVideoObserver = new MutationObserver(mutations => {
                    for (const mutation of mutations) {
                        if (mutation.target.classList.contains('video-opened')) {
                            this.productGallery.classList.add('remove-navigation');
                        } else {
                            this.productGallery.classList.remove('remove-navigation');
                        }
                    }
                });
                this.productGallery.querySelectorAll('video-popup').forEach(elm => {
                    productVideoObserver.observe(elm, { attributes: true, childList: false, subtree: false });
                })

            }

        }

    }

    thumbnailNavigationHelper(index = 0) {
        this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i) => {
            if (i == index)
                elm.classList.add('active');
            else
                elm.classList.remove('active');
        });
    }

    onVariantChangeHandler(e) {
        const variant = e.target.currentVariant;
        if (this.productGallery != null && variant && variant.featured_media != null) {
            const variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
            if (variantImg) {
                if (this.productGallery.dataset.style == "slider" || (this.productGallery.dataset.style == "scroll" && this.productGallery.querySelector('css-slider').sliderEnabled)) {
                    this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
                } else {
                    const originalOrder = [...this.productGallery.querySelectorAll('.product-gallery-item')].sort((a, b) => {
                        return a.dataset.index - b.dataset.index;
                    });
                    originalOrder.forEach(elm => {
                        this.productGallery.querySelector('css-slider').append(elm)
                    })
                    this.productGallery.querySelector('css-slider').prepend(variantImg);
                    this.reorderThumbnailNavigation();
                }
            }
        }
    }

    reorderThumbnailNavigation(index) {
        if (this.productGallery != null) {
            const reversedGallerySlidesForThumbnails = [...this.productGallery.querySelectorAll('.product-gallery-item')].reverse();
            const galleryThumbnailsHolder = this.querySelector('.product-gallery__thumbnails .thumbnails-holder .thumbnails');
            reversedGallerySlidesForThumbnails.forEach(slide => {
                galleryThumbnailsHolder.prepend(this.querySelector(`.product-gallery__thumbnails .thumbnail[data-faux-index="${slide.dataset.index}"]`));
            })
            this.querySelectorAll('.product-gallery__thumbnails .thumbnails-holder .thumbnail').forEach((elm, i) => {
                elm.setAttribute('data-index', i);
            })
            this.thumbnailNavigationHelper(0);
            setTimeout(() => {
                this.thumbnailNavigationHelper(0);
            }, 10);
        }
    }

}
customElements.define("product-page", ProductPage);
class ProductReviews {
    constructor(e) {
        const t = new MutationObserver((e, t) => {
            for (const r of e) r.addedNodes.length > 0 && r.addedNodes.forEach(e => {
                "DIV" == e.tagName && e.classList.contains("spr-container") && (this.init(e), t.disconnect())
            })
        });
        e.classList.add("observe-reviews"), e.querySelector(".spr-review") ? this.init(e.querySelector(".spr-container")) : t.observe(e, {
            childList: !0
        })
    }
    init(e) {
        e.closest("#shopify-product-reviews").classList.remove("observe-reviews");
        const t = document.querySelector(".product__price-reviews .rating-text");
        document.querySelector("#shopify-product-reviews .spr-summary-starrating") && document.querySelector("#shopify-product-reviews .spr-summary-starrating").prepend(this.createRatingEl(document.querySelector(".spr-summary-starrating"), "spr-custom-rating", t ? t.textContent : "")), e.classList = "site-box-container container--fullscreen box--can-stick";
        const r = e.querySelector(".spr-header");
        r && (r.classList = "site-box box--big lap--box--small-fl palm--box--small-fl box--typo-big box--center-align box--column-flow box__heading", r.setAttribute("data-order", "0"), r.style.borderBottom = "none", r.innerHTML = `<div class="site-box-content" \n    \t\tstyle="display:flex;flex-direction:column"\n    \t>${r.innerHTML}</div>`, r.querySelector(".spr-header-title").classList = "h1 title", r.querySelector(".spr-summary-actions-newreview").classList.add("button"), r.querySelector(".spr-summary-actions-newreview").classList.add("button--solid"));
        const i = e.querySelector(".spr-content");
        i && (i.classList = "site-box box--big lap--box--bigger box__text box--typo-big box--center-align box--column-flow", i.setAttribute("data-order", "1"), i.querySelector(".spr-reviews").children.length <= 0 && (i.querySelector(".spr-reviews").innerHTML = `<p class="text-size--larger">${KROWN.settings.locales.product_no_reviews}</p>`, i.querySelector(".spr-reviews").style.display = "block", r.querySelector(".spr-summary-caption").remove()), i.querySelector(".spr-reviews").classList = "site-box-content");
        const s = document.createElement("div");
        s.id = "spr-form-modal", s.innerHTML = '<div id="spr-form" class="spr-form-holder address-popup">\n      <div class="basicLightboxClose" tabindex="1">×</div>\n    </div>', document.querySelector(".spr-summary-actions-newreview").setAttribute("onclick", "");
        const o = basicLightbox.create(s, {
            trigger: document.querySelector(".spr-summary-actions-newreview"),
            focus: 'input[type="text"]'
        });
        o.element().querySelector(".spr-form-holder").prepend(e.querySelector(".spr-form")), o.element().querySelector(".spr-form").style.display = "block", o.element().querySelector(".spr-button").classList = "button button--solid", this.redoReviews(e)
    }
    redoReviews(e) {
        e.querySelectorAll(".spr-review").forEach(e => {
            e.querySelector(".spr-review-header").insertBefore(this.createRatingEl(e, "spr-review-custom-rating"), e.querySelector(".spr-review-header").firstElementChild.nextSibling)
        });
        const t = e.querySelector(".spr-pagination");
        t && (t.querySelector("div").classList = "pagination pagination--small", t.querySelector(".spr-pagination-prev") && (t.querySelector(".spr-pagination-prev a").innerHTML = '<svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">\n\t\t\t\t\t\t\t<path d="M1.46442 7.94185L0.0502109 6.52764L6.53549 0.0423586L7.94971 1.45657L1.46442 7.94185Z" fill="#262627"/>\n\t\t\t\t\t\t\t<path d="M0.0503636 6.49961L1.46458 5.0854L7.94986 11.5707L6.53564 12.9849L0.0503636 6.49961Z" fill="#262627"/>\n\t\t\t\t\t\t</svg>'), t.querySelector(".spr-pagination-next") && (t.querySelector(".spr-pagination-next a").innerHTML = '<svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">\n\t\t\t\t\t\t<path d="M6.53557 5.08537L7.94979 6.49958L1.46451 12.9849L0.0502931 11.5706L6.53557 5.08537Z" fill="#262627"/>\n\t\t\t\t\t\t<path d="M7.94964 6.52761L6.53542 7.94182L0.050142 1.45654L1.46436 0.0423289L7.94964 6.52761Z" fill="#262627"/>\n\t\t\t\t\t</svg>')), this.reviewsObserver && this.reviewsObserver.disconnect(), this.reviewsObserver = new MutationObserver((t, r) => {
            for (const r of t) this.redoReviews(e)
        }), this.reviewsObserver.observe(e, {
            childList: !0,
            subtree: !0
        })
    }
    createRatingEl(e, t, r = "") {
        const i = e.querySelectorAll(".spr-icon-star").length,
            s = e.querySelectorAll(".spr-icon-star-half-alt").length > 0 ? ".5" : "",
            o = document.createElement("span");
        return o.classList = t + " text-size--regular", o.innerHTML = `<span>${""!=r?r:i+s+" / 5"}</span>${KROWN.settings.symbols.star}`, o
    }
}
document.getElementById("shopify-product-reviews") && new ProductReviews(document.getElementById("shopify-product-reviews"));
class CountdownClock extends HTMLElement {
    constructor() {
        super(), this.daysEl = this.querySelector(".days"), this.hoursEl = this.querySelector(".hours"), this.minutesEl = this.querySelector(".minutes"), this.secondsEl = this.querySelector(".seconds");
        const s = this.dataset.date.split(",");
        this.COUNT = new Date(s[0], s[1] - 1, s[2], s[3]);
        const n = parseInt(this.dataset.timezone),
            t = this.COUNT.getTimezoneOffset() / -60;
        t != n && this.COUNT.setHours(parseInt(s[3]) + t - n), this._countdownBannerInterval = setInterval(this._countEachSecond.bind(this), 1e3), this._countEachSecond(), this.classList.contains("hide") && this.classList.remove("hide")
    }
    _countEachSecond() {
        const s = (new Date).getTime(),
            n = this.COUNT - s,
            t = Math.floor(n / 864e5),
            e = Math.floor(n % 864e5 / 36e5),
            a = Math.floor(n % 36e5 / 6e4),
            i = Math.floor(n % 6e4 / 1e3);
        this.daysEl.innerHTML = t < 10 ? `<span>0</span><span>${t}</span>` : t.toString().split("").map(s => `<span>${s}</span>`).join(""), this.hoursEl.innerHTML = e < 10 ? `<span>0</span><span>${e}</span>` : e.toString().split("").map(s => `<span>${s}</span>`).join(""), this.minutesEl.innerHTML = a < 10 ? `<span>0</span><span>${a}</span>` : a.toString().split("").map(s => `<span>${s}</span>`).join(""), this.secondsEl.innerHTML = i < 10 ? `<span>0</span><span>${i}</span>` : i.toString().split("").map(s => `<span>${s}</span>`).join(""), n < 0 && (clearInterval(this._countdownBannerInterval), this.daysEl.innerHTML = "<span>0</span><span>0</span>", this.hoursEl.innerHTML = "<span>0</span><span>0</span>", this.minutesEl.innerHTML = "<span>0</span><span>0</span>", this.secondsEl.innerHTML = "<span>0</span><span>0</span>")
    }
}
customElements.define("countdown-clock", CountdownClock);
window.lightMapStyle = [{
    featureType: "water",
    elementType: "geometry",
    stylers: [{
        color: "#e9e9e9"
    }, {
        lightness: 17
    }]
}, {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [{
        color: "#f5f5f5"
    }, {
        lightness: 20
    }]
}, {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [{
        color: "#ffffff"
    }, {
        lightness: 17
    }]
}, {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{
        color: "#ffffff"
    }, {
        lightness: 29
    }, {
        weight: .2
    }]
}, {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [{
        color: "#ffffff"
    }, {
        lightness: 18
    }]
}, {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [{
        color: "#ffffff"
    }, {
        lightness: 16
    }]
}, {
    featureType: "poi",
    elementType: "geometry",
    stylers: [{
        color: "#f5f5f5"
    }, {
        lightness: 21
    }]
}, {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{
        color: "#dedede"
    }, {
        lightness: 21
    }]
}, {
    elementType: "labels.text.stroke",
    stylers: [{
        visibility: "on"
    }, {
        color: "#ffffff"
    }, {
        lightness: 16
    }]
}, {
    elementType: "labels.text.fill",
    stylers: [{
        saturation: 36
    }, {
        color: "#333333"
    }, {
        lightness: 40
    }]
}, {
    elementType: "labels.icon",
    stylers: [{
        visibility: "off"
    }]
}, {
    featureType: "transit",
    elementType: "geometry",
    stylers: [{
        color: "#f2f2f2"
    }, {
        lightness: 19
    }]
}, {
    featureType: "administrative",
    elementType: "geometry.fill",
    stylers: [{
        color: "#fefefe"
    }, {
        lightness: 20
    }]
}, {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [{
        color: "#fefefe"
    }, {
        lightness: 17
    }, {
        weight: 1.2
    }]
}], window.darkMapStyle = [{
    featureType: "all",
    elementType: "labels.text.fill",
    stylers: [{
        saturation: 36
    }, {
        color: "#000000"
    }, {
        lightness: 40
    }]
}, {
    featureType: "all",
    elementType: "labels.text.stroke",
    stylers: [{
        visibility: "on"
    }, {
        color: "#000000"
    }, {
        lightness: 16
    }]
}, {
    featureType: "all",
    elementType: "labels.icon",
    stylers: [{
        visibility: "off"
    }]
}, {
    featureType: "administrative",
    elementType: "geometry.fill",
    stylers: [{
        color: "#000000"
    }, {
        lightness: 20
    }]
}, {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [{
        color: "#000000"
    }, {
        lightness: 17
    }, {
        weight: 1.2
    }]
}, {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [{
        color: "#000000"
    }, {
        lightness: 20
    }]
}, {
    featureType: "poi",
    elementType: "geometry",
    stylers: [{
        color: "#000000"
    }, {
        lightness: 21
    }]
}, {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [{
        color: "#000000"
    }, {
        lightness: 17
    }]
}, {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{
        color: "#000000"
    }, {
        lightness: 29
    }, {
        weight: .2
    }]
}, {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [{
        color: "#000000"
    }, {
        lightness: 18
    }]
}, {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [{
        color: "#000000"
    }, {
        lightness: 16
    }]
}, {
    featureType: "transit",
    elementType: "geometry",
    stylers: [{
        color: "#000000"
    }, {
        lightness: 19
    }]
}, {
    featureType: "water",
    elementType: "geometry",
    stylers: [{
        color: "#000000"
    }, {
        lightness: 17
    }]
}];
class ContactMap extends HTMLElement {
    constructor() {
        super(), this.mount()
    }
    mount() {
        if ("" != this.dataset.address)
            if ("undefined" != typeof google && google.maps) this._createMap();
            else if (window.loadingGoogleMapsScript) this.ti = setInterval(() => {
            "undefined" != typeof google && (clearInterval(this.ti), this._createMap())
        }, 100);
        else {
            window.loadingGoogleMapsScript = !0;
            var e = document.createElement("script");
            e.onload = () => {
                this._createMap()
            }, e.async = !0, e.src = "https://maps.googleapis.com/maps/api/js?v=3&key=" + this.dataset.key, document.head.appendChild(e)
        }
    }
    _createMap() {
        const e = this.querySelector(".contact-map-object"),
            t = this.querySelector(".contact-map-address-holder"),
            o = "map-coords-" + e.id;
        let l, s, r, a = null != localStorage.getItem(o) ? JSON.parse(localStorage.getItem(o)) : null,
            n = 0,
            i = 0;
        null != a && a.address == e.dataset.address && (n = a.lat, i = a.long), l = new google.maps.Geocoder, r = e.dataset.address;
        const y = {
            zoom: parseInt(e.dataset.zoom),
            center: new google.maps.LatLng(n, i),
            streetViewControl: !1,
            scrollwheel: !1,
            panControl: !0,
            mapTypeControl: !1,
            overviewMapControl: !1,
            zoomControl: !0,
            draggable: !0,
            styles: "light" == e.dataset.style ? window.lightMapStyle : window.darkMapStyle
        };
        if (s = new google.maps.Map(document.getElementById(e.id), y), 0 != n || 0 != i) {
            const o = {
                position: new google.maps.LatLng(n, i),
                map: s,
                title: r
            };
            "none" != e.dataset.marker && (o.icon = {
                url: e.dataset.marker,
                scaledSize: new google.maps.Size(60, 60)
            }), t.querySelector("a").setAttribute("href", `http://www.google.com/maps/place/${n},${i}`);
            const l = t.innerHTML,
                a = new google.maps.InfoWindow({
                    content: l
                }),
                y = new google.maps.Marker(o);
            y.addListener("click", () => {
                a.open(s, y), window.innerWidth < 480 ? document.querySelector(".template-page-contact .box__heading .title").style.marginTop = "50px" : window.innerWidth < 768 && (document.querySelector(".template-page-contact .box__heading .title").style.marginTop = "100px")
            }), window.innerWidth > 768 ? s.panBy(-150, 150) : s.panBy(-75, 75)
        } else l && l.geocode({
            address: r
        }, (l, a) => {
            if (a == google.maps.GeocoderStatus.OK)
                if (a != google.maps.GeocoderStatus.ZERO_RESULTS) {
                    s.setCenter(l[0].geometry.location);
                    const a = {
                        position: l[0].geometry.location,
                        map: s,
                        title: r
                    };
                    "none" != e.dataset.marker && (a.icon = {
                        url: e.dataset.marker,
                        scaledSize: new google.maps.Size(60, 60)
                    }), t.querySelector("a").setAttribute("href", `http://www.google.com/maps/place/${l[0].geometry.location.lat()},${l[0].geometry.location.lng()}`);
                    const n = t.innerHTML,
                        i = new google.maps.InfoWindow({
                            content: n
                        }),
                        y = new google.maps.Marker(a);
                    y.addListener("click", () => {
                        i.open(s, y)
                    }), window.innerWidth > 768 ? s.panBy(-150, 150) : s.panBy(-75, 75), localStorage.setItem(o, JSON.stringify({
                        address: e.dataset.address,
                        lat: l[0].geometry.location.lat(),
                        long: l[0].geometry.location.lng()
                    }))
                } else alert("No results found for the given address");
            else console.log("Geocode was not successful for the following reason: " + a)
        })
    }
}
customElements.define("contact-map", ContactMap);
class SplitScreenSlider extends CSSSlider {
    constructor() {
        super(), this.mount(), this.RESIZE_SliderHelper = debounce(() => {
            this.unmount(), this.mount()
        }, 300), window.addEventListener("resize", this.RESIZE_SliderHelper, {
            passive: !0
        })
    }
    mount() {
        this._currentScroll = window.scrollY, this._headerHeight = document.getElementById("site-header").offsetHeight, this._fullWidth = !!this.classList.contains("layout-full"), this._scrollEnabled = !0, this._screenHeight = Math.min(window.innerHeight, window.screen.availHeight), this.slides = this.querySelectorAll(".slider-item"), this.slidesMedia = this.querySelectorAll(".slider-item-media > div"), this.slidesBlackArray = this.querySelectorAll(".slider-item-media-overlay"), this.headings = this.querySelectorAll(".box__heading"), this.slides.forEach((e, s) => {
            0 == s || window.scrollY >= this._getOffsetTop(e) ? this.slidesMedia[s].style.height = "100%" : this.slidesMedia[s].style.height = "0", window.preloadImages(e)
        }), this.addEventListener("ready", () => {
            this.slides = this.querySelectorAll(".slider-item"), this.slidesMediaElements = this.querySelectorAll(".slider-item-media-element"), this.addEventListener("scroll", () => {
                const e = -this.element.scrollLeft;
                this.slides.forEach((s, t) => {
                    const i = this.slidesMediaElements[t];
                    i && (i.style.transform = `translateX(${-1*(s.offsetLeft+e)/3}px)`)
                })
            })
        });
        let e = -1,
            s = -1;
        this.SCROLL_SliderHelper = () => {
            const t = window.scrollY >= 0 ? window.scrollY : 0,
                i = this._getOffsetTop(this);
            if (this._scrollEnabled) {
                let l = 0;
                if (t + this._headerHeight - this._headerHeight < this._getOffsetTop(this) && !this.classList.contains("back-to-normal") && this.classList.add("back-to-normal"), this.slides.forEach((e, s) => {
                        this._checkVisible(e) && (l = s)
                    }), l != s && (this._currentScroll < t && s > 0 ? this._scrollMedia(l, this.slides[s], this.slides[e], this.slidesMedia[s], this.slidesBlackArray[e], this._screenHeight) : this._currentScroll > window.scrollY && s > 0 && this._scrollMedia(l, this.slides[s], this.slides[e], this.slidesMedia[s], this.slidesBlackArray[e], 0), s = l, e = l - 1), 0 == l && t + this._screenHeight >= i + this.offsetHeight && !this.classList.contains("back-to-normal")) this.classList.add("back-to-normal");
                else if (l > 0) {
                    const s = t - i - this._screenHeight * (l - 1);
                    this.classList.contains("back-to-normal") || this._scrollMedia(l, this.slides[l], this.slides[e], this.slidesMedia[l], this.slidesBlackArray[e], s), t + this._screenHeight >= i + this.offsetHeight && !this.classList.contains("back-to-normal") ? this.classList.add("back-to-normal") : t + this._screenHeight < i + this.offsetHeight && this.classList.contains("back-to-normal") && this.classList.remove("back-to-normal")
                }
            }
            this._currentScroll = t
        }, window.addEventListener("scroll", this.SCROLL_SliderHelper, {
            passive: !0
        }), this.SCROLL_SliderHelper()
    }
    unmount() {
        window.removeEventListener("scroll", this.SCROLL_SliderHelper)
    }
    _scrollMedia(e, s, t, i, l, r) {
        this._fullWidth ? i.style.clipPath = `polygon(0 ${window.innerHeight-r+1}px, 100% ${window.innerHeight-r+1}px, 100% 100%, 0% 100%)` : i.style.height = r + "px", l && (l.style.opacity = "" + Math.ceil(30 * r / this._screenHeight) / 100)
    }
    _checkVisible(e) {
        const s = e.getBoundingClientRect(),
            t = Math.max(document.documentElement.clientHeight, window.innerHeight);
        return !(s.bottom < 0 || s.top - t >= 0)
    }
    _getOffsetTop(e) {
        if (!e.getClientRects().length) return 0;
        const s = e.getBoundingClientRect(),
            t = e.ownerDocument.defaultView;
        return s.top + t.pageYOffset
    }
}
customElements.define("split-screen-slider", SplitScreenSlider);
class VideoCustomElement extends HTMLElement {
    constructor() {
        super();
        const e = this.querySelector("video");
        !e.paused || e.readyState >= 2 ? this.classList.add("loaded") : (this.fallbackT = setTimeout((e => {
            if (e.paused) {
                const e = this.closest(".slider-item-media").querySelector("img");
                this.remove(), ribSetSize(e)
            }
        }).bind(this, e), 3e3), e.addEventListener("canplay", e => {
            this.classList.add("loaded"), clearTimeout(this.fallbackT)
        }))
    }
}
customElements.define("video-custom-element", VideoCustomElement);
class VideoModalPopup extends HTMLElement {
    constructor() {
        super();
        basicLightbox.create(`<div class="video-popup-holder" data-video-type="${this.dataset.videoType}" style="padding-top: 56.25%">\n\t\t\t\t${this.querySelector("template").content.firstElementChild.innerHTML}\n\t\t\t\t<div class="basicLightboxClose">${KROWN.settings.symbols.close}</div>\n\t\t\t</div>`, {
            trigger: this,
            onShow: e => {
                setTimeout((e => {
                    switch (e.element().querySelector(".video-popup-holder").dataset.videoType) {
                        case "youtube":
                            e.element().querySelector(".js-youtube").contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
                            break;
                        case "vimeo":
                            e.element().querySelector(".js-vimeo").contentWindow.postMessage('{"method":"play"}', "*")
                    }
                }).bind(this, e), 500)
            }
        })
    }
}
customElements.define("video-modal-popup", VideoModalPopup);
KROWN.themeName = "Split", KROWN.themeVersion = "3.2.3";
const executeOnceOnDomContentLoaded = () => {
    reframe(document.querySelectorAll('.rte iframe[src*="youtube"], .rte iframe[src*="vimeo"]'));
    let e = document.activeElement;
    document.addEventListener("keyup", t => {
        t.keyCode == window.KEYCODES.TAB && (e.classList.contains("focus") && t.target != e && e.classList.remove("focus"), (t.target.classList.contains("product-variant__input") || t.target.classList.contains("button") || t.target.classList.contains("product-item") || t.target.classList.contains("spr-summary-actions-newreview") || t.target.classList.contains("site-box-content-to-focus")) && t.target.classList.add("focus"), e = document.activeElement)
    }), window.location.pathname.includes("/challenge") && setTimeout(() => {
        window.scroll({
            top: 0,
            behavior: "auto"
        })
    }, 300), document.querySelectorAll(".rte a img").forEach(e => {
        e.parentNode.style.border = "none"
    }), setTimeout(() => {
        document.querySelector("modal-box quick-view-product") && document.querySelector("modal-box quick-view-product").init(), document.querySelector("modal-box quick-add-to-cart") && (document.querySelector("modal-box quick-add-to-cart").init(), document.querySelector("modal-box product-form").init())
    }, 3050)
};
"loading" !== document.readyState ? executeOnceOnDomContentLoaded() : document.addEventListener("DOMContentLoaded", executeOnceOnDomContentLoaded), window.refreshCart || (window.refreshCart = () => {
    fetch("?section_id=cart-helper").then(e => e.text()).then(e => {
        const t = (new DOMParser).parseFromString(e, "text/html"),
            o = t.getElementById("AjaxCartForm").innerHTML,
            n = t.getElementById("AjaxCartSubtotal").innerHTML,
            a = document.getElementById("AjaxCartForm");
        a.innerHTML = o, a.ajaxifyCartItems(), document.querySelector("[data-header-cart-count]").textContent = a.querySelector("[data-cart-count]").textContent, document.getElementById("AjaxCartSubtotal").innerHTML = n, window.preloadImages(a), document.getElementById("site-cart").show(), document.getElementById("cart-recommendations") && (document.getElementById("cart-recommendations").innerHTML = "", document.getElementById("cart-recommendations").generateRecommendations())
    })
});